
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire95f9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire95f9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iIpFz", function(module, exports) {

$parcel$export(module.exports, "sharedConfig", () => $da003f7f010eb820$export$2cb4986bed338027);
$parcel$export(module.exports, "createRoot", () => $da003f7f010eb820$export$882461b6382ed46c);
$parcel$export(module.exports, "untrack", () => $da003f7f010eb820$export$363ebc4b78b8f807);
$parcel$export(module.exports, "createSignal", () => $da003f7f010eb820$export$c1e1e1ecbbe76a5);
$parcel$export(module.exports, "createRenderEffect", () => $da003f7f010eb820$export$314dade334ae905d);
$parcel$export(module.exports, "createEffect", () => $da003f7f010eb820$export$7ea7134f704deda4);
$parcel$export(module.exports, "createMemo", () => $da003f7f010eb820$export$c0c6c8b9c16bf6aa);
$parcel$export(module.exports, "onCleanup", () => $da003f7f010eb820$export$b36e5eaa3e8c43ab);
$parcel$export(module.exports, "runWithOwner", () => $da003f7f010eb820$export$c14f3e3abbc7d6b5);
$parcel$export(module.exports, "onMount", () => $da003f7f010eb820$export$1e848a9e87980bd5);
$parcel$export(module.exports, "getOwner", () => $da003f7f010eb820$export$5f4ed0d56c2c0edf);
$parcel$export(module.exports, "enableHydration", () => $da003f7f010eb820$export$849801d35d2160c9);
$parcel$export(module.exports, "createComponent", () => $da003f7f010eb820$export$60e54eaca7e7fb38);
$parcel$export(module.exports, "splitProps", () => $da003f7f010eb820$export$45029c61b0073d87);
$parcel$export(module.exports, "For", () => $da003f7f010eb820$export$bdf530073099ce9f);
$parcel$export(module.exports, "Show", () => $da003f7f010eb820$export$f6a3d19be20f5819);
$parcel$export(module.exports, "Switch", () => $da003f7f010eb820$export$b5d5cf8927ab7262);
$parcel$export(module.exports, "Match", () => $da003f7f010eb820$export$f421feb8fad20413);
let $da003f7f010eb820$var$taskIdCounter = 1, $da003f7f010eb820$var$isCallbackScheduled = false, $da003f7f010eb820$var$isPerformingWork = false, $da003f7f010eb820$var$taskQueue = [], $da003f7f010eb820$var$currentTask = null, $da003f7f010eb820$var$shouldYieldToHost = null, $da003f7f010eb820$var$yieldInterval = 5, $da003f7f010eb820$var$deadline = 0, $da003f7f010eb820$var$maxYieldInterval = 300, $da003f7f010eb820$var$maxDeadline = 0, $da003f7f010eb820$var$scheduleCallback = null, $da003f7f010eb820$var$scheduledCallback = null;
const $da003f7f010eb820$var$maxSigned31BitInt = 1073741823;
function $da003f7f010eb820$var$setupScheduler() {
    const channel = new MessageChannel(), port1 = channel.port1, port = channel.port2;
    if (typeof port1.unref === "function") port1.unref();
    if (typeof port.unref === "function") port.unref();
    $da003f7f010eb820$var$scheduleCallback = ()=>port.postMessage(null);
    port1.onmessage = ()=>{
        if ($da003f7f010eb820$var$scheduledCallback !== null) {
            const currentTime = performance.now();
            $da003f7f010eb820$var$deadline = currentTime + $da003f7f010eb820$var$yieldInterval;
            $da003f7f010eb820$var$maxDeadline = currentTime + $da003f7f010eb820$var$maxYieldInterval;
            try {
                const hasMoreWork = $da003f7f010eb820$var$scheduledCallback(currentTime);
                if (!hasMoreWork) $da003f7f010eb820$var$scheduledCallback = null;
                else port.postMessage(null);
            } catch (error) {
                port.postMessage(null);
                throw error;
            }
        }
    };
    if (navigator && navigator.scheduling && navigator.scheduling.isInputPending) {
        const scheduling = navigator.scheduling;
        $da003f7f010eb820$var$shouldYieldToHost = ()=>{
            const currentTime = performance.now();
            if (currentTime >= $da003f7f010eb820$var$deadline) {
                if (scheduling.isInputPending()) return true;
                return currentTime >= $da003f7f010eb820$var$maxDeadline;
            } else return false;
        };
    } else $da003f7f010eb820$var$shouldYieldToHost = ()=>performance.now() >= $da003f7f010eb820$var$deadline;
}
function $da003f7f010eb820$var$enqueue(taskQueue, task) {
    function findIndex() {
        let m = 0;
        let n = taskQueue.length - 1;
        while(m <= n){
            const k = n + m >> 1;
            const cmp = task.expirationTime - taskQueue[k].expirationTime;
            if (cmp > 0) m = k + 1;
            else if (cmp < 0) n = k - 1;
            else return k;
        }
        return m;
    }
    taskQueue.splice(findIndex(), 0, task);
}
function $da003f7f010eb820$export$4b5e076b3a2fbe0a(fn, options) {
    if (!$da003f7f010eb820$var$scheduleCallback) $da003f7f010eb820$var$setupScheduler();
    let startTime = performance.now(), timeout = $da003f7f010eb820$var$maxSigned31BitInt;
    if (options && options.timeout) timeout = options.timeout;
    const newTask = {
        id: $da003f7f010eb820$var$taskIdCounter++,
        fn: fn,
        startTime: startTime,
        expirationTime: startTime + timeout
    };
    $da003f7f010eb820$var$enqueue($da003f7f010eb820$var$taskQueue, newTask);
    if (!$da003f7f010eb820$var$isCallbackScheduled && !$da003f7f010eb820$var$isPerformingWork) {
        $da003f7f010eb820$var$isCallbackScheduled = true;
        $da003f7f010eb820$var$scheduledCallback = $da003f7f010eb820$var$flushWork;
        $da003f7f010eb820$var$scheduleCallback();
    }
    return newTask;
}
function $da003f7f010eb820$export$b888d8f981c07a46(task) {
    task.fn = null;
}
function $da003f7f010eb820$var$flushWork(initialTime) {
    $da003f7f010eb820$var$isCallbackScheduled = false;
    $da003f7f010eb820$var$isPerformingWork = true;
    try {
        return $da003f7f010eb820$var$workLoop(initialTime);
    } finally{
        $da003f7f010eb820$var$currentTask = null;
        $da003f7f010eb820$var$isPerformingWork = false;
    }
}
function $da003f7f010eb820$var$workLoop(initialTime) {
    let currentTime = initialTime;
    $da003f7f010eb820$var$currentTask = $da003f7f010eb820$var$taskQueue[0] || null;
    while($da003f7f010eb820$var$currentTask !== null){
        if ($da003f7f010eb820$var$currentTask.expirationTime > currentTime && $da003f7f010eb820$var$shouldYieldToHost()) break;
        const callback = $da003f7f010eb820$var$currentTask.fn;
        if (callback !== null) {
            $da003f7f010eb820$var$currentTask.fn = null;
            const didUserCallbackTimeout = $da003f7f010eb820$var$currentTask.expirationTime <= currentTime;
            callback(didUserCallbackTimeout);
            currentTime = performance.now();
            if ($da003f7f010eb820$var$currentTask === $da003f7f010eb820$var$taskQueue[0]) $da003f7f010eb820$var$taskQueue.shift();
        } else $da003f7f010eb820$var$taskQueue.shift();
        $da003f7f010eb820$var$currentTask = $da003f7f010eb820$var$taskQueue[0] || null;
    }
    return $da003f7f010eb820$var$currentTask !== null;
}
const $da003f7f010eb820$export$2cb4986bed338027 = {
    context: undefined,
    registry: undefined,
    effects: undefined,
    done: false,
    getContextId () {
        return $da003f7f010eb820$var$getContextId(this.context.count);
    },
    getNextContextId () {
        return $da003f7f010eb820$var$getContextId(this.context.count++);
    }
};
function $da003f7f010eb820$var$getContextId(count) {
    const num = String(count), len = num.length - 1;
    return $da003f7f010eb820$export$2cb4986bed338027.context.id + (len ? String.fromCharCode(96 + len) : "") + num;
}
function $da003f7f010eb820$var$setHydrateContext(context) {
    $da003f7f010eb820$export$2cb4986bed338027.context = context;
}
function $da003f7f010eb820$var$nextHydrateContext() {
    return {
        ...$da003f7f010eb820$export$2cb4986bed338027.context,
        id: $da003f7f010eb820$export$2cb4986bed338027.getNextContextId(),
        count: 0
    };
}
const $da003f7f010eb820$var$IS_DEV = false;
const $da003f7f010eb820$export$34b67c27f2ca7498 = (a, b)=>a === b;
const $da003f7f010eb820$export$5cd89106e2f6c2c5 = Symbol("solid-proxy");
const $da003f7f010eb820$var$SUPPORTS_PROXY = typeof Proxy === "function";
const $da003f7f010eb820$export$17a675b7c02a7b1d = Symbol("solid-track");
const $da003f7f010eb820$export$f5625ae0b78e5b20 = Symbol("solid-dev-component");
const $da003f7f010eb820$var$signalOptions = {
    equals: $da003f7f010eb820$export$34b67c27f2ca7498
};
let $da003f7f010eb820$var$ERROR = null;
let $da003f7f010eb820$var$runEffects = $da003f7f010eb820$var$runQueue;
const $da003f7f010eb820$var$STALE = 1;
const $da003f7f010eb820$var$PENDING = 2;
const $da003f7f010eb820$var$UNOWNED = {
    owned: null,
    cleanups: null,
    context: null,
    owner: null
};
const $da003f7f010eb820$var$NO_INIT = {};
var $da003f7f010eb820$var$Owner = null;
let $da003f7f010eb820$var$Transition = null;
let $da003f7f010eb820$var$Scheduler = null;
let $da003f7f010eb820$var$ExternalSourceConfig = null;
let $da003f7f010eb820$var$Listener = null;
let $da003f7f010eb820$var$Updates = null;
let $da003f7f010eb820$var$Effects = null;
let $da003f7f010eb820$var$ExecCount = 0;
function $da003f7f010eb820$export$882461b6382ed46c(fn, detachedOwner) {
    const listener = $da003f7f010eb820$var$Listener, owner = $da003f7f010eb820$var$Owner, unowned = fn.length === 0, current = detachedOwner === undefined ? owner : detachedOwner, root = unowned ? $da003f7f010eb820$var$UNOWNED : {
        owned: null,
        cleanups: null,
        context: current ? current.context : null,
        owner: current
    }, updateFn = unowned ? fn : ()=>fn(()=>$da003f7f010eb820$export$363ebc4b78b8f807(()=>$da003f7f010eb820$var$cleanNode(root)));
    $da003f7f010eb820$var$Owner = root;
    $da003f7f010eb820$var$Listener = null;
    try {
        return $da003f7f010eb820$var$runUpdates(updateFn, true);
    } finally{
        $da003f7f010eb820$var$Listener = listener;
        $da003f7f010eb820$var$Owner = owner;
    }
}
function $da003f7f010eb820$export$c1e1e1ecbbe76a5(value, options) {
    options = options ? Object.assign({}, $da003f7f010eb820$var$signalOptions, options) : $da003f7f010eb820$var$signalOptions;
    const s = {
        value: value,
        observers: null,
        observerSlots: null,
        comparator: options.equals || undefined
    };
    const setter = (value)=>{
        if (typeof value === "function") {
            if ($da003f7f010eb820$var$Transition && $da003f7f010eb820$var$Transition.running && $da003f7f010eb820$var$Transition.sources.has(s)) value = value(s.tValue);
            else value = value(s.value);
        }
        return $da003f7f010eb820$var$writeSignal(s, value);
    };
    return [
        $da003f7f010eb820$var$readSignal.bind(s),
        setter
    ];
}
function $da003f7f010eb820$export$234a23cdc77e6a3d(fn, value, options) {
    const c = $da003f7f010eb820$var$createComputation(fn, value, true, $da003f7f010eb820$var$STALE);
    if ($da003f7f010eb820$var$Scheduler && $da003f7f010eb820$var$Transition && $da003f7f010eb820$var$Transition.running) $da003f7f010eb820$var$Updates.push(c);
    else $da003f7f010eb820$var$updateComputation(c);
}
function $da003f7f010eb820$export$314dade334ae905d(fn, value, options) {
    const c = $da003f7f010eb820$var$createComputation(fn, value, false, $da003f7f010eb820$var$STALE);
    if ($da003f7f010eb820$var$Scheduler && $da003f7f010eb820$var$Transition && $da003f7f010eb820$var$Transition.running) $da003f7f010eb820$var$Updates.push(c);
    else $da003f7f010eb820$var$updateComputation(c);
}
function $da003f7f010eb820$export$7ea7134f704deda4(fn, value, options) {
    $da003f7f010eb820$var$runEffects = $da003f7f010eb820$var$runUserEffects;
    const c = $da003f7f010eb820$var$createComputation(fn, value, false, $da003f7f010eb820$var$STALE), s = $da003f7f010eb820$var$SuspenseContext && $da003f7f010eb820$export$fae74005e78b1a27($da003f7f010eb820$var$SuspenseContext);
    if (s) c.suspense = s;
    if (!options || !options.render) c.user = true;
    $da003f7f010eb820$var$Effects ? $da003f7f010eb820$var$Effects.push(c) : $da003f7f010eb820$var$updateComputation(c);
}
function $da003f7f010eb820$export$5ce14d95ebb45542(onInvalidate, options) {
    let fn;
    const c = $da003f7f010eb820$var$createComputation(()=>{
        fn ? fn() : $da003f7f010eb820$export$363ebc4b78b8f807(onInvalidate);
        fn = undefined;
    }, undefined, false, 0), s = $da003f7f010eb820$var$SuspenseContext && $da003f7f010eb820$export$fae74005e78b1a27($da003f7f010eb820$var$SuspenseContext);
    if (s) c.suspense = s;
    c.user = true;
    return (tracking)=>{
        fn = tracking;
        $da003f7f010eb820$var$updateComputation(c);
    };
}
function $da003f7f010eb820$export$c0c6c8b9c16bf6aa(fn, value, options) {
    options = options ? Object.assign({}, $da003f7f010eb820$var$signalOptions, options) : $da003f7f010eb820$var$signalOptions;
    const c = $da003f7f010eb820$var$createComputation(fn, value, true, 0);
    c.observers = null;
    c.observerSlots = null;
    c.comparator = options.equals || undefined;
    if ($da003f7f010eb820$var$Scheduler && $da003f7f010eb820$var$Transition && $da003f7f010eb820$var$Transition.running) {
        c.tState = $da003f7f010eb820$var$STALE;
        $da003f7f010eb820$var$Updates.push(c);
    } else $da003f7f010eb820$var$updateComputation(c);
    return $da003f7f010eb820$var$readSignal.bind(c);
}
function $da003f7f010eb820$var$isPromise(v) {
    return v && typeof v === "object" && "then" in v;
}
function $da003f7f010eb820$export$edd172c6c83c39cc(pSource, pFetcher, pOptions) {
    let source;
    let fetcher;
    let options;
    if (typeof pFetcher === "function") {
        source = pSource;
        fetcher = pFetcher;
        options = pOptions || {};
    } else {
        source = true;
        fetcher = pSource;
        options = pFetcher || {};
    }
    let pr = null, initP = $da003f7f010eb820$var$NO_INIT, id = null, loadedUnderTransition = false, scheduled = false, resolved = "initialValue" in options, dynamic = typeof source === "function" && $da003f7f010eb820$export$c0c6c8b9c16bf6aa(source);
    const contexts = new Set(), [value, setValue] = (options.storage || $da003f7f010eb820$export$c1e1e1ecbbe76a5)(options.initialValue), [error, setError] = $da003f7f010eb820$export$c1e1e1ecbbe76a5(undefined), [track, trigger] = $da003f7f010eb820$export$c1e1e1ecbbe76a5(undefined, {
        equals: false
    }), [state, setState] = $da003f7f010eb820$export$c1e1e1ecbbe76a5(resolved ? "ready" : "unresolved");
    if ($da003f7f010eb820$var$Owner) $da003f7f010eb820$export$b36e5eaa3e8c43ab(()=>{
        for (const c of contexts.keys())c.decrement();
        contexts.clear();
        if ($da003f7f010eb820$var$Transition && pr) $da003f7f010eb820$var$Transition.promises.delete(pr);
        pr = null;
    });
    if ($da003f7f010eb820$export$2cb4986bed338027.context) {
        id = $da003f7f010eb820$export$2cb4986bed338027.getNextContextId();
        if (options.ssrLoadFrom === "initial") initP = options.initialValue;
        else if ($da003f7f010eb820$export$2cb4986bed338027.load && $da003f7f010eb820$export$2cb4986bed338027.has(id)) initP = $da003f7f010eb820$export$2cb4986bed338027.load(id);
    }
    function loadEnd(p, v, error, key) {
        if (pr === p) {
            pr = null;
            key !== undefined && (resolved = true);
            if ((p === initP || v === initP) && options.onHydrated) queueMicrotask(()=>options.onHydrated(key, {
                    value: v
                }));
            initP = $da003f7f010eb820$var$NO_INIT;
            if ($da003f7f010eb820$var$Transition && p && loadedUnderTransition) {
                $da003f7f010eb820$var$Transition.promises.delete(p);
                loadedUnderTransition = false;
                $da003f7f010eb820$var$runUpdates(()=>{
                    $da003f7f010eb820$var$Transition.running = true;
                    completeLoad(v, error);
                }, false);
            } else completeLoad(v, error);
        }
        return v;
    }
    function completeLoad(v, err) {
        $da003f7f010eb820$var$runUpdates(()=>{
            if (err === undefined) setValue(()=>v);
            setState(err !== undefined ? "errored" : resolved ? "ready" : "unresolved");
            setError(err);
            for (const c of contexts.keys())c.decrement();
            contexts.clear();
        }, false);
    }
    function read() {
        const c = $da003f7f010eb820$var$SuspenseContext && $da003f7f010eb820$export$fae74005e78b1a27($da003f7f010eb820$var$SuspenseContext), v = value(), err = error();
        if (err !== undefined && !pr) throw err;
        if ($da003f7f010eb820$var$Listener && !$da003f7f010eb820$var$Listener.user && c) $da003f7f010eb820$export$234a23cdc77e6a3d(()=>{
            track();
            if (pr) {
                if (c.resolved && $da003f7f010eb820$var$Transition && loadedUnderTransition) $da003f7f010eb820$var$Transition.promises.add(pr);
                else if (!contexts.has(c)) {
                    c.increment();
                    contexts.add(c);
                }
            }
        });
        return v;
    }
    function load(refetching = true) {
        if (refetching !== false && scheduled) return;
        scheduled = false;
        const lookup = dynamic ? dynamic() : source;
        loadedUnderTransition = $da003f7f010eb820$var$Transition && $da003f7f010eb820$var$Transition.running;
        if (lookup == null || lookup === false) {
            loadEnd(pr, $da003f7f010eb820$export$363ebc4b78b8f807(value));
            return;
        }
        if ($da003f7f010eb820$var$Transition && pr) $da003f7f010eb820$var$Transition.promises.delete(pr);
        let error;
        const p = initP !== $da003f7f010eb820$var$NO_INIT ? initP : $da003f7f010eb820$export$363ebc4b78b8f807(()=>{
            try {
                return fetcher(lookup, {
                    value: value(),
                    refetching: refetching
                });
            } catch (fetcherError) {
                error = fetcherError;
            }
        });
        if (error !== undefined) {
            loadEnd(pr, undefined, $da003f7f010eb820$var$castError(error), lookup);
            return;
        } else if (!$da003f7f010eb820$var$isPromise(p)) {
            loadEnd(pr, p, undefined, lookup);
            return p;
        }
        pr = p;
        if ("v" in p) {
            if (p.s === 1) loadEnd(pr, p.v, undefined, lookup);
            else loadEnd(pr, undefined, $da003f7f010eb820$var$castError(p.v), lookup);
            return p;
        }
        scheduled = true;
        queueMicrotask(()=>scheduled = false);
        $da003f7f010eb820$var$runUpdates(()=>{
            setState(resolved ? "refreshing" : "pending");
            trigger();
        }, false);
        return p.then((v)=>loadEnd(p, v, undefined, lookup), (e)=>loadEnd(p, undefined, $da003f7f010eb820$var$castError(e), lookup));
    }
    Object.defineProperties(read, {
        state: {
            get: ()=>state()
        },
        error: {
            get: ()=>error()
        },
        loading: {
            get () {
                const s = state();
                return s === "pending" || s === "refreshing";
            }
        },
        latest: {
            get () {
                if (!resolved) return read();
                const err = error();
                if (err && !pr) throw err;
                return value();
            }
        }
    });
    let owner = $da003f7f010eb820$var$Owner;
    if (dynamic) $da003f7f010eb820$export$234a23cdc77e6a3d(()=>(owner = $da003f7f010eb820$var$Owner, load(false)));
    else load(false);
    return [
        read,
        {
            refetch: (info)=>$da003f7f010eb820$export$c14f3e3abbc7d6b5(owner, ()=>load(info)),
            mutate: setValue
        }
    ];
}
function $da003f7f010eb820$export$e673efccd97e4223(source, options) {
    let t, timeout = options ? options.timeoutMs : undefined;
    const node = $da003f7f010eb820$var$createComputation(()=>{
        if (!t || !t.fn) t = $da003f7f010eb820$export$4b5e076b3a2fbe0a(()=>setDeferred(()=>node.value), timeout !== undefined ? {
            timeout: timeout
        } : undefined);
        return source();
    }, undefined, true);
    const [deferred, setDeferred] = $da003f7f010eb820$export$c1e1e1ecbbe76a5($da003f7f010eb820$var$Transition && $da003f7f010eb820$var$Transition.running && $da003f7f010eb820$var$Transition.sources.has(node) ? node.tValue : node.value, options);
    $da003f7f010eb820$var$updateComputation(node);
    setDeferred(()=>$da003f7f010eb820$var$Transition && $da003f7f010eb820$var$Transition.running && $da003f7f010eb820$var$Transition.sources.has(node) ? node.tValue : node.value);
    return deferred;
}
function $da003f7f010eb820$export$595d22ed68ca2841(source, fn = $da003f7f010eb820$export$34b67c27f2ca7498, options) {
    const subs = new Map();
    const node = $da003f7f010eb820$var$createComputation((p)=>{
        const v = source();
        for (const [key, val] of subs.entries())if (fn(key, v) !== fn(key, p)) for (const c of val.values()){
            if ($da003f7f010eb820$var$Transition && $da003f7f010eb820$var$Transition.running) c.tState = $da003f7f010eb820$var$STALE;
            else c.state = $da003f7f010eb820$var$STALE;
            if (c.pure) $da003f7f010eb820$var$Updates.push(c);
            else $da003f7f010eb820$var$Effects.push(c);
        }
        return v;
    }, undefined, true, $da003f7f010eb820$var$STALE);
    $da003f7f010eb820$var$updateComputation(node);
    return (key)=>{
        const listener = $da003f7f010eb820$var$Listener;
        if (listener) {
            let l;
            if (l = subs.get(key)) l.add(listener);
            else subs.set(key, l = new Set([
                listener
            ]));
            $da003f7f010eb820$export$b36e5eaa3e8c43ab(()=>{
                l.delete(listener);
                !l.size && subs.delete(key);
            });
        }
        return fn(key, $da003f7f010eb820$var$Transition && $da003f7f010eb820$var$Transition.running && $da003f7f010eb820$var$Transition.sources.has(node) ? node.tValue : node.value);
    };
}
function $da003f7f010eb820$export$712ea50be43a7858(fn) {
    return $da003f7f010eb820$var$runUpdates(fn, false);
}
function $da003f7f010eb820$export$363ebc4b78b8f807(fn) {
    if (!$da003f7f010eb820$var$ExternalSourceConfig && $da003f7f010eb820$var$Listener === null) return fn();
    const listener = $da003f7f010eb820$var$Listener;
    $da003f7f010eb820$var$Listener = null;
    try {
        if ($da003f7f010eb820$var$ExternalSourceConfig) return $da003f7f010eb820$var$ExternalSourceConfig.untrack(fn);
        return fn();
    } finally{
        $da003f7f010eb820$var$Listener = listener;
    }
}
function $da003f7f010eb820$export$af631764ddc44097(deps, fn, options) {
    const isArray = Array.isArray(deps);
    let prevInput;
    let defer = options && options.defer;
    return (prevValue)=>{
        let input;
        if (isArray) {
            input = Array(deps.length);
            for(let i = 0; i < deps.length; i++)input[i] = deps[i]();
        } else input = deps();
        if (defer) {
            defer = false;
            return prevValue;
        }
        const result = $da003f7f010eb820$export$363ebc4b78b8f807(()=>fn(input, prevInput, prevValue));
        prevInput = input;
        return result;
    };
}
function $da003f7f010eb820$export$1e848a9e87980bd5(fn) {
    $da003f7f010eb820$export$7ea7134f704deda4(()=>$da003f7f010eb820$export$363ebc4b78b8f807(fn));
}
function $da003f7f010eb820$export$b36e5eaa3e8c43ab(fn) {
    if ($da003f7f010eb820$var$Owner === null) ;
    else if ($da003f7f010eb820$var$Owner.cleanups === null) $da003f7f010eb820$var$Owner.cleanups = [
        fn
    ];
    else $da003f7f010eb820$var$Owner.cleanups.push(fn);
    return fn;
}
function $da003f7f010eb820$export$3dede90624df3ba9(fn, handler) {
    $da003f7f010eb820$var$ERROR || ($da003f7f010eb820$var$ERROR = Symbol("error"));
    $da003f7f010eb820$var$Owner = $da003f7f010eb820$var$createComputation(undefined, undefined, true);
    $da003f7f010eb820$var$Owner.context = {
        ...$da003f7f010eb820$var$Owner.context,
        [$da003f7f010eb820$var$ERROR]: [
            handler
        ]
    };
    if ($da003f7f010eb820$var$Transition && $da003f7f010eb820$var$Transition.running) $da003f7f010eb820$var$Transition.sources.add($da003f7f010eb820$var$Owner);
    try {
        return fn();
    } catch (err) {
        $da003f7f010eb820$var$handleError(err);
    } finally{
        $da003f7f010eb820$var$Owner = $da003f7f010eb820$var$Owner.owner;
    }
}
function $da003f7f010eb820$export$12abb5141c6fdc9c() {
    return $da003f7f010eb820$var$Listener;
}
function $da003f7f010eb820$export$5f4ed0d56c2c0edf() {
    return $da003f7f010eb820$var$Owner;
}
function $da003f7f010eb820$export$c14f3e3abbc7d6b5(o, fn) {
    const prev = $da003f7f010eb820$var$Owner;
    const prevListener = $da003f7f010eb820$var$Listener;
    $da003f7f010eb820$var$Owner = o;
    $da003f7f010eb820$var$Listener = null;
    try {
        return $da003f7f010eb820$var$runUpdates(fn, true);
    } catch (err) {
        $da003f7f010eb820$var$handleError(err);
    } finally{
        $da003f7f010eb820$var$Owner = prev;
        $da003f7f010eb820$var$Listener = prevListener;
    }
}
function $da003f7f010eb820$export$45e8540700504e87(scheduler = $da003f7f010eb820$export$4b5e076b3a2fbe0a) {
    $da003f7f010eb820$var$Scheduler = scheduler;
}
function $da003f7f010eb820$export$7568632d0d33d16d(fn) {
    if ($da003f7f010eb820$var$Transition && $da003f7f010eb820$var$Transition.running) {
        fn();
        return $da003f7f010eb820$var$Transition.done;
    }
    const l = $da003f7f010eb820$var$Listener;
    const o = $da003f7f010eb820$var$Owner;
    return Promise.resolve().then(()=>{
        $da003f7f010eb820$var$Listener = l;
        $da003f7f010eb820$var$Owner = o;
        let t;
        if ($da003f7f010eb820$var$Scheduler || $da003f7f010eb820$var$SuspenseContext) {
            t = $da003f7f010eb820$var$Transition || ($da003f7f010eb820$var$Transition = {
                sources: new Set(),
                effects: [],
                promises: new Set(),
                disposed: new Set(),
                queue: new Set(),
                running: true
            });
            t.done || (t.done = new Promise((res)=>t.resolve = res));
            t.running = true;
        }
        $da003f7f010eb820$var$runUpdates(fn, false);
        $da003f7f010eb820$var$Listener = $da003f7f010eb820$var$Owner = null;
        return t ? t.done : undefined;
    });
}
const [$da003f7f010eb820$var$transPending, $da003f7f010eb820$var$setTransPending] = /*@__PURE__*/ $da003f7f010eb820$export$c1e1e1ecbbe76a5(false);
function $da003f7f010eb820$export$7b286972b8d8ccbf() {
    return [
        $da003f7f010eb820$var$transPending,
        $da003f7f010eb820$export$7568632d0d33d16d
    ];
}
function $da003f7f010eb820$var$resumeEffects(e) {
    $da003f7f010eb820$var$Effects.push.apply($da003f7f010eb820$var$Effects, e);
    e.length = 0;
}
function $da003f7f010eb820$export$fd42f52fd3ae1109(defaultValue, options) {
    const id = Symbol("context");
    return {
        id: id,
        Provider: $da003f7f010eb820$var$createProvider(id),
        defaultValue: defaultValue
    };
}
function $da003f7f010eb820$export$fae74005e78b1a27(context) {
    let value;
    return $da003f7f010eb820$var$Owner && $da003f7f010eb820$var$Owner.context && (value = $da003f7f010eb820$var$Owner.context[context.id]) !== undefined ? value : context.defaultValue;
}
function $da003f7f010eb820$export$bacb5cc5a11aef16(fn) {
    const children = $da003f7f010eb820$export$c0c6c8b9c16bf6aa(fn);
    const memo = $da003f7f010eb820$export$c0c6c8b9c16bf6aa(()=>$da003f7f010eb820$var$resolveChildren(children()));
    memo.toArray = ()=>{
        const c = memo();
        return Array.isArray(c) ? c : c != null ? [
            c
        ] : [];
    };
    return memo;
}
let $da003f7f010eb820$var$SuspenseContext;
function $da003f7f010eb820$var$getSuspenseContext() {
    return $da003f7f010eb820$var$SuspenseContext || ($da003f7f010eb820$var$SuspenseContext = $da003f7f010eb820$export$fd42f52fd3ae1109());
}
function $da003f7f010eb820$export$315ab94ce87a624f(factory, untrack = (fn)=>fn()) {
    if ($da003f7f010eb820$var$ExternalSourceConfig) {
        const { factory: oldFactory, untrack: oldUntrack } = $da003f7f010eb820$var$ExternalSourceConfig;
        $da003f7f010eb820$var$ExternalSourceConfig = {
            factory: (fn, trigger)=>{
                const oldSource = oldFactory(fn, trigger);
                const source = factory((x)=>oldSource.track(x), trigger);
                return {
                    track: (x)=>source.track(x),
                    dispose () {
                        source.dispose();
                        oldSource.dispose();
                    }
                };
            },
            untrack: (fn)=>oldUntrack(()=>untrack(fn))
        };
    } else $da003f7f010eb820$var$ExternalSourceConfig = {
        factory: factory,
        untrack: untrack
    };
}
function $da003f7f010eb820$var$readSignal() {
    const runningTransition = $da003f7f010eb820$var$Transition && $da003f7f010eb820$var$Transition.running;
    if (this.sources && (runningTransition ? this.tState : this.state)) {
        if ((runningTransition ? this.tState : this.state) === $da003f7f010eb820$var$STALE) $da003f7f010eb820$var$updateComputation(this);
        else {
            const updates = $da003f7f010eb820$var$Updates;
            $da003f7f010eb820$var$Updates = null;
            $da003f7f010eb820$var$runUpdates(()=>$da003f7f010eb820$var$lookUpstream(this), false);
            $da003f7f010eb820$var$Updates = updates;
        }
    }
    if ($da003f7f010eb820$var$Listener) {
        const observers = this.observers;
        if (!observers || observers[observers.length - 1] !== $da003f7f010eb820$var$Listener) {
            const sSlot = observers ? observers.length : 0;
            if (!$da003f7f010eb820$var$Listener.sources) {
                $da003f7f010eb820$var$Listener.sources = [
                    this
                ];
                $da003f7f010eb820$var$Listener.sourceSlots = [
                    sSlot
                ];
            } else {
                $da003f7f010eb820$var$Listener.sources.push(this);
                $da003f7f010eb820$var$Listener.sourceSlots.push(sSlot);
            }
            if (!observers) {
                this.observers = [
                    $da003f7f010eb820$var$Listener
                ];
                this.observerSlots = [
                    $da003f7f010eb820$var$Listener.sources.length - 1
                ];
            } else {
                observers.push($da003f7f010eb820$var$Listener);
                this.observerSlots.push($da003f7f010eb820$var$Listener.sources.length - 1);
            }
        }
    }
    if (runningTransition && $da003f7f010eb820$var$Transition.sources.has(this)) return this.tValue;
    return this.value;
}
function $da003f7f010eb820$var$writeSignal(node, value, isComp) {
    let current = $da003f7f010eb820$var$Transition && $da003f7f010eb820$var$Transition.running && $da003f7f010eb820$var$Transition.sources.has(node) ? node.tValue : node.value;
    if (!node.comparator || !node.comparator(current, value)) {
        if ($da003f7f010eb820$var$Transition) {
            const TransitionRunning = $da003f7f010eb820$var$Transition.running;
            if (TransitionRunning || !isComp && $da003f7f010eb820$var$Transition.sources.has(node)) {
                $da003f7f010eb820$var$Transition.sources.add(node);
                node.tValue = value;
            }
            if (!TransitionRunning) node.value = value;
        } else node.value = value;
        if (node.observers && node.observers.length) $da003f7f010eb820$var$runUpdates(()=>{
            for(let i = 0; i < node.observers.length; i += 1){
                const o = node.observers[i];
                const TransitionRunning = $da003f7f010eb820$var$Transition && $da003f7f010eb820$var$Transition.running;
                if (TransitionRunning && $da003f7f010eb820$var$Transition.disposed.has(o)) continue;
                if (TransitionRunning ? !o.tState : !o.state) {
                    if (o.pure) $da003f7f010eb820$var$Updates.push(o);
                    else $da003f7f010eb820$var$Effects.push(o);
                    if (o.observers) $da003f7f010eb820$var$markDownstream(o);
                }
                if (!TransitionRunning) o.state = $da003f7f010eb820$var$STALE;
                else o.tState = $da003f7f010eb820$var$STALE;
            }
            if ($da003f7f010eb820$var$Updates.length > 10e5) {
                $da003f7f010eb820$var$Updates = [];
                $da003f7f010eb820$var$IS_DEV;
                throw new Error();
            }
        }, false);
    }
    return value;
}
function $da003f7f010eb820$var$updateComputation(node) {
    if (!node.fn) return;
    $da003f7f010eb820$var$cleanNode(node);
    const time = $da003f7f010eb820$var$ExecCount;
    $da003f7f010eb820$var$runComputation(node, $da003f7f010eb820$var$Transition && $da003f7f010eb820$var$Transition.running && $da003f7f010eb820$var$Transition.sources.has(node) ? node.tValue : node.value, time);
    if ($da003f7f010eb820$var$Transition && !$da003f7f010eb820$var$Transition.running && $da003f7f010eb820$var$Transition.sources.has(node)) queueMicrotask(()=>{
        $da003f7f010eb820$var$runUpdates(()=>{
            $da003f7f010eb820$var$Transition && ($da003f7f010eb820$var$Transition.running = true);
            $da003f7f010eb820$var$Listener = $da003f7f010eb820$var$Owner = node;
            $da003f7f010eb820$var$runComputation(node, node.tValue, time);
            $da003f7f010eb820$var$Listener = $da003f7f010eb820$var$Owner = null;
        }, false);
    });
}
function $da003f7f010eb820$var$runComputation(node, value, time) {
    let nextValue;
    const owner = $da003f7f010eb820$var$Owner, listener = $da003f7f010eb820$var$Listener;
    $da003f7f010eb820$var$Listener = $da003f7f010eb820$var$Owner = node;
    try {
        nextValue = node.fn(value);
    } catch (err) {
        if (node.pure) {
            if ($da003f7f010eb820$var$Transition && $da003f7f010eb820$var$Transition.running) {
                node.tState = $da003f7f010eb820$var$STALE;
                node.tOwned && node.tOwned.forEach($da003f7f010eb820$var$cleanNode);
                node.tOwned = undefined;
            } else {
                node.state = $da003f7f010eb820$var$STALE;
                node.owned && node.owned.forEach($da003f7f010eb820$var$cleanNode);
                node.owned = null;
            }
        }
        node.updatedAt = time + 1;
        return $da003f7f010eb820$var$handleError(err);
    } finally{
        $da003f7f010eb820$var$Listener = listener;
        $da003f7f010eb820$var$Owner = owner;
    }
    if (!node.updatedAt || node.updatedAt <= time) {
        if (node.updatedAt != null && "observers" in node) $da003f7f010eb820$var$writeSignal(node, nextValue, true);
        else if ($da003f7f010eb820$var$Transition && $da003f7f010eb820$var$Transition.running && node.pure) {
            if (!$da003f7f010eb820$var$Transition.sources.has(node)) node.value = nextValue;
            $da003f7f010eb820$var$Transition.sources.add(node);
            node.tValue = nextValue;
        } else node.value = nextValue;
        node.updatedAt = time;
    }
}
function $da003f7f010eb820$var$createComputation(fn, init, pure, state = $da003f7f010eb820$var$STALE, options) {
    const c = {
        fn: fn,
        state: state,
        updatedAt: null,
        owned: null,
        sources: null,
        sourceSlots: null,
        cleanups: null,
        value: init,
        owner: $da003f7f010eb820$var$Owner,
        context: $da003f7f010eb820$var$Owner ? $da003f7f010eb820$var$Owner.context : null,
        pure: pure
    };
    if ($da003f7f010eb820$var$Transition && $da003f7f010eb820$var$Transition.running) {
        c.state = 0;
        c.tState = state;
    }
    if ($da003f7f010eb820$var$Owner === null) ;
    else if ($da003f7f010eb820$var$Owner !== $da003f7f010eb820$var$UNOWNED) {
        if ($da003f7f010eb820$var$Transition && $da003f7f010eb820$var$Transition.running && $da003f7f010eb820$var$Owner.pure) {
            if (!$da003f7f010eb820$var$Owner.tOwned) $da003f7f010eb820$var$Owner.tOwned = [
                c
            ];
            else $da003f7f010eb820$var$Owner.tOwned.push(c);
        } else if (!$da003f7f010eb820$var$Owner.owned) $da003f7f010eb820$var$Owner.owned = [
            c
        ];
        else $da003f7f010eb820$var$Owner.owned.push(c);
    }
    if ($da003f7f010eb820$var$ExternalSourceConfig && c.fn) {
        const sourceFn = c.fn;
        const [track, trigger] = $da003f7f010eb820$export$c1e1e1ecbbe76a5(undefined, {
            equals: false
        });
        const ordinary = $da003f7f010eb820$var$ExternalSourceConfig.factory(sourceFn, trigger);
        $da003f7f010eb820$export$b36e5eaa3e8c43ab(()=>ordinary.dispose());
        let inTransition;
        let trackedOrdinary = false;
        const triggerInTransition = ()=>$da003f7f010eb820$export$7568632d0d33d16d(trigger).then(()=>{
                if (inTransition) {
                    inTransition.dispose();
                    inTransition = undefined;
                    if (!trackedOrdinary) trigger();
                }
            });
        c.fn = (x)=>{
            track();
            if ($da003f7f010eb820$var$Transition && $da003f7f010eb820$var$Transition.running) {
                if (!inTransition) inTransition = $da003f7f010eb820$var$ExternalSourceConfig.factory(sourceFn, triggerInTransition);
                return inTransition.track(x);
            }
            trackedOrdinary = true;
            return ordinary.track(x);
        };
    }
    return c;
}
function $da003f7f010eb820$var$runTop(node) {
    const runningTransition = $da003f7f010eb820$var$Transition && $da003f7f010eb820$var$Transition.running;
    if ((runningTransition ? node.tState : node.state) === 0) return;
    if ((runningTransition ? node.tState : node.state) === $da003f7f010eb820$var$PENDING) return $da003f7f010eb820$var$lookUpstream(node);
    if (node.suspense && $da003f7f010eb820$export$363ebc4b78b8f807(node.suspense.inFallback)) return node.suspense.effects.push(node);
    const ancestors = [
        node
    ];
    while((node = node.owner) && (!node.updatedAt || node.updatedAt < $da003f7f010eb820$var$ExecCount)){
        if (runningTransition && $da003f7f010eb820$var$Transition.disposed.has(node)) return;
        if (runningTransition ? node.tState : node.state) ancestors.push(node);
    }
    for(let i = ancestors.length - 1; i >= 0; i--){
        node = ancestors[i];
        if (runningTransition) {
            let top = node, prev = ancestors[i + 1];
            while((top = top.owner) && top !== prev){
                if ($da003f7f010eb820$var$Transition.disposed.has(top)) return;
            }
        }
        if ((runningTransition ? node.tState : node.state) === $da003f7f010eb820$var$STALE) $da003f7f010eb820$var$updateComputation(node);
        else if ((runningTransition ? node.tState : node.state) === $da003f7f010eb820$var$PENDING) {
            const updates = $da003f7f010eb820$var$Updates;
            $da003f7f010eb820$var$Updates = null;
            $da003f7f010eb820$var$runUpdates(()=>$da003f7f010eb820$var$lookUpstream(node, ancestors[0]), false);
            $da003f7f010eb820$var$Updates = updates;
        }
    }
}
function $da003f7f010eb820$var$runUpdates(fn, init) {
    if ($da003f7f010eb820$var$Updates) return fn();
    let wait = false;
    if (!init) $da003f7f010eb820$var$Updates = [];
    if ($da003f7f010eb820$var$Effects) wait = true;
    else $da003f7f010eb820$var$Effects = [];
    $da003f7f010eb820$var$ExecCount++;
    try {
        const res = fn();
        $da003f7f010eb820$var$completeUpdates(wait);
        return res;
    } catch (err) {
        if (!wait) $da003f7f010eb820$var$Effects = null;
        $da003f7f010eb820$var$Updates = null;
        $da003f7f010eb820$var$handleError(err);
    }
}
function $da003f7f010eb820$var$completeUpdates(wait) {
    if ($da003f7f010eb820$var$Updates) {
        if ($da003f7f010eb820$var$Scheduler && $da003f7f010eb820$var$Transition && $da003f7f010eb820$var$Transition.running) $da003f7f010eb820$var$scheduleQueue($da003f7f010eb820$var$Updates);
        else $da003f7f010eb820$var$runQueue($da003f7f010eb820$var$Updates);
        $da003f7f010eb820$var$Updates = null;
    }
    if (wait) return;
    let res;
    if ($da003f7f010eb820$var$Transition) {
        if (!$da003f7f010eb820$var$Transition.promises.size && !$da003f7f010eb820$var$Transition.queue.size) {
            const sources = $da003f7f010eb820$var$Transition.sources;
            const disposed = $da003f7f010eb820$var$Transition.disposed;
            $da003f7f010eb820$var$Effects.push.apply($da003f7f010eb820$var$Effects, $da003f7f010eb820$var$Transition.effects);
            res = $da003f7f010eb820$var$Transition.resolve;
            for (const e of $da003f7f010eb820$var$Effects){
                "tState" in e && (e.state = e.tState);
                delete e.tState;
            }
            $da003f7f010eb820$var$Transition = null;
            $da003f7f010eb820$var$runUpdates(()=>{
                for (const d of disposed)$da003f7f010eb820$var$cleanNode(d);
                for (const v of sources){
                    v.value = v.tValue;
                    if (v.owned) for(let i = 0, len = v.owned.length; i < len; i++)$da003f7f010eb820$var$cleanNode(v.owned[i]);
                    if (v.tOwned) v.owned = v.tOwned;
                    delete v.tValue;
                    delete v.tOwned;
                    v.tState = 0;
                }
                $da003f7f010eb820$var$setTransPending(false);
            }, false);
        } else if ($da003f7f010eb820$var$Transition.running) {
            $da003f7f010eb820$var$Transition.running = false;
            $da003f7f010eb820$var$Transition.effects.push.apply($da003f7f010eb820$var$Transition.effects, $da003f7f010eb820$var$Effects);
            $da003f7f010eb820$var$Effects = null;
            $da003f7f010eb820$var$setTransPending(true);
            return;
        }
    }
    const e = $da003f7f010eb820$var$Effects;
    $da003f7f010eb820$var$Effects = null;
    if (e.length) $da003f7f010eb820$var$runUpdates(()=>$da003f7f010eb820$var$runEffects(e), false);
    if (res) res();
}
function $da003f7f010eb820$var$runQueue(queue) {
    for(let i = 0; i < queue.length; i++)$da003f7f010eb820$var$runTop(queue[i]);
}
function $da003f7f010eb820$var$scheduleQueue(queue) {
    for(let i = 0; i < queue.length; i++){
        const item = queue[i];
        const tasks = $da003f7f010eb820$var$Transition.queue;
        if (!tasks.has(item)) {
            tasks.add(item);
            $da003f7f010eb820$var$Scheduler(()=>{
                tasks.delete(item);
                $da003f7f010eb820$var$runUpdates(()=>{
                    $da003f7f010eb820$var$Transition.running = true;
                    $da003f7f010eb820$var$runTop(item);
                }, false);
                $da003f7f010eb820$var$Transition && ($da003f7f010eb820$var$Transition.running = false);
            });
        }
    }
}
function $da003f7f010eb820$var$runUserEffects(queue) {
    let i, userLength = 0;
    for(i = 0; i < queue.length; i++){
        const e = queue[i];
        if (!e.user) $da003f7f010eb820$var$runTop(e);
        else queue[userLength++] = e;
    }
    if ($da003f7f010eb820$export$2cb4986bed338027.context) {
        if ($da003f7f010eb820$export$2cb4986bed338027.count) {
            $da003f7f010eb820$export$2cb4986bed338027.effects || ($da003f7f010eb820$export$2cb4986bed338027.effects = []);
            $da003f7f010eb820$export$2cb4986bed338027.effects.push(...queue.slice(0, userLength));
            return;
        }
        $da003f7f010eb820$var$setHydrateContext();
    }
    if ($da003f7f010eb820$export$2cb4986bed338027.effects && ($da003f7f010eb820$export$2cb4986bed338027.done || !$da003f7f010eb820$export$2cb4986bed338027.count)) {
        queue = [
            ...$da003f7f010eb820$export$2cb4986bed338027.effects,
            ...queue
        ];
        userLength += $da003f7f010eb820$export$2cb4986bed338027.effects.length;
        delete $da003f7f010eb820$export$2cb4986bed338027.effects;
    }
    for(i = 0; i < userLength; i++)$da003f7f010eb820$var$runTop(queue[i]);
}
function $da003f7f010eb820$var$lookUpstream(node, ignore) {
    const runningTransition = $da003f7f010eb820$var$Transition && $da003f7f010eb820$var$Transition.running;
    if (runningTransition) node.tState = 0;
    else node.state = 0;
    for(let i = 0; i < node.sources.length; i += 1){
        const source = node.sources[i];
        if (source.sources) {
            const state = runningTransition ? source.tState : source.state;
            if (state === $da003f7f010eb820$var$STALE) {
                if (source !== ignore && (!source.updatedAt || source.updatedAt < $da003f7f010eb820$var$ExecCount)) $da003f7f010eb820$var$runTop(source);
            } else if (state === $da003f7f010eb820$var$PENDING) $da003f7f010eb820$var$lookUpstream(source, ignore);
        }
    }
}
function $da003f7f010eb820$var$markDownstream(node) {
    const runningTransition = $da003f7f010eb820$var$Transition && $da003f7f010eb820$var$Transition.running;
    for(let i = 0; i < node.observers.length; i += 1){
        const o = node.observers[i];
        if (runningTransition ? !o.tState : !o.state) {
            if (runningTransition) o.tState = $da003f7f010eb820$var$PENDING;
            else o.state = $da003f7f010eb820$var$PENDING;
            if (o.pure) $da003f7f010eb820$var$Updates.push(o);
            else $da003f7f010eb820$var$Effects.push(o);
            o.observers && $da003f7f010eb820$var$markDownstream(o);
        }
    }
}
function $da003f7f010eb820$var$cleanNode(node) {
    let i;
    if (node.sources) while(node.sources.length){
        const source = node.sources.pop(), index = node.sourceSlots.pop(), obs = source.observers;
        if (obs && obs.length) {
            const n = obs.pop(), s = source.observerSlots.pop();
            if (index < obs.length) {
                n.sourceSlots[s] = index;
                obs[index] = n;
                source.observerSlots[index] = s;
            }
        }
    }
    if (node.tOwned) {
        for(i = node.tOwned.length - 1; i >= 0; i--)$da003f7f010eb820$var$cleanNode(node.tOwned[i]);
        delete node.tOwned;
    }
    if ($da003f7f010eb820$var$Transition && $da003f7f010eb820$var$Transition.running && node.pure) $da003f7f010eb820$var$reset(node, true);
    else if (node.owned) {
        for(i = node.owned.length - 1; i >= 0; i--)$da003f7f010eb820$var$cleanNode(node.owned[i]);
        node.owned = null;
    }
    if (node.cleanups) {
        for(i = node.cleanups.length - 1; i >= 0; i--)node.cleanups[i]();
        node.cleanups = null;
    }
    if ($da003f7f010eb820$var$Transition && $da003f7f010eb820$var$Transition.running) node.tState = 0;
    else node.state = 0;
}
function $da003f7f010eb820$var$reset(node, top) {
    if (!top) {
        node.tState = 0;
        $da003f7f010eb820$var$Transition.disposed.add(node);
    }
    if (node.owned) for(let i = 0; i < node.owned.length; i++)$da003f7f010eb820$var$reset(node.owned[i]);
}
function $da003f7f010eb820$var$castError(err) {
    if (err instanceof Error) return err;
    return new Error(typeof err === "string" ? err : "Unknown error", {
        cause: err
    });
}
function $da003f7f010eb820$var$runErrors(err, fns, owner) {
    try {
        for (const f of fns)f(err);
    } catch (e) {
        $da003f7f010eb820$var$handleError(e, owner && owner.owner || null);
    }
}
function $da003f7f010eb820$var$handleError(err, owner = $da003f7f010eb820$var$Owner) {
    const fns = $da003f7f010eb820$var$ERROR && owner && owner.context && owner.context[$da003f7f010eb820$var$ERROR];
    const error = $da003f7f010eb820$var$castError(err);
    if (!fns) throw error;
    if ($da003f7f010eb820$var$Effects) $da003f7f010eb820$var$Effects.push({
        fn () {
            $da003f7f010eb820$var$runErrors(error, fns, owner);
        },
        state: $da003f7f010eb820$var$STALE
    });
    else $da003f7f010eb820$var$runErrors(error, fns, owner);
}
function $da003f7f010eb820$var$resolveChildren(children) {
    if (typeof children === "function" && !children.length) return $da003f7f010eb820$var$resolveChildren(children());
    if (Array.isArray(children)) {
        const results = [];
        for(let i = 0; i < children.length; i++){
            const result = $da003f7f010eb820$var$resolveChildren(children[i]);
            if (Array.isArray(result)) {
                if (result.length < 32768) results.push.apply(results, result);
                else for(let j = 0; j < result.length; j++)results.push(result[j]);
            } else results.push(result);
        }
        return results;
    }
    return children;
}
function $da003f7f010eb820$var$createProvider(id, options) {
    return function provider(props) {
        let res;
        $da003f7f010eb820$export$314dade334ae905d(()=>res = $da003f7f010eb820$export$363ebc4b78b8f807(()=>{
                $da003f7f010eb820$var$Owner.context = {
                    ...$da003f7f010eb820$var$Owner.context,
                    [id]: props.value
                };
                return $da003f7f010eb820$export$bacb5cc5a11aef16(()=>props.children);
            }), undefined);
        return res;
    };
}
function $da003f7f010eb820$export$2288787135a8f66e(fn) {
    $da003f7f010eb820$var$ERROR || ($da003f7f010eb820$var$ERROR = Symbol("error"));
    if ($da003f7f010eb820$var$Owner === null) ;
    else if ($da003f7f010eb820$var$Owner.context === null || !$da003f7f010eb820$var$Owner.context[$da003f7f010eb820$var$ERROR]) {
        $da003f7f010eb820$var$Owner.context = {
            ...$da003f7f010eb820$var$Owner.context,
            [$da003f7f010eb820$var$ERROR]: [
                fn
            ]
        };
        $da003f7f010eb820$var$mutateContext($da003f7f010eb820$var$Owner, $da003f7f010eb820$var$ERROR, [
            fn
        ]);
    } else $da003f7f010eb820$var$Owner.context[$da003f7f010eb820$var$ERROR].push(fn);
}
function $da003f7f010eb820$var$mutateContext(o, key, value) {
    if (o.owned) for(let i = 0; i < o.owned.length; i++){
        if (o.owned[i].context === o.context) $da003f7f010eb820$var$mutateContext(o.owned[i], key, value);
        if (!o.owned[i].context) {
            o.owned[i].context = o.context;
            $da003f7f010eb820$var$mutateContext(o.owned[i], key, value);
        } else if (!o.owned[i].context[key]) {
            o.owned[i].context[key] = value;
            $da003f7f010eb820$var$mutateContext(o.owned[i], key, value);
        }
    }
}
function $da003f7f010eb820$export$5ab46cbf6120b33a(input) {
    return {
        subscribe (observer) {
            if (!(observer instanceof Object) || observer == null) throw new TypeError("Expected the observer to be an object.");
            const handler = typeof observer === "function" ? observer : observer.next && observer.next.bind(observer);
            if (!handler) return {
                unsubscribe () {}
            };
            const dispose = $da003f7f010eb820$export$882461b6382ed46c((disposer)=>{
                $da003f7f010eb820$export$7ea7134f704deda4(()=>{
                    const v = input();
                    $da003f7f010eb820$export$363ebc4b78b8f807(()=>handler(v));
                });
                return disposer;
            });
            if ($da003f7f010eb820$export$5f4ed0d56c2c0edf()) $da003f7f010eb820$export$b36e5eaa3e8c43ab(dispose);
            return {
                unsubscribe () {
                    dispose();
                }
            };
        },
        [Symbol.observable || "@@observable"] () {
            return this;
        }
    };
}
function $da003f7f010eb820$export$6788812c4e6611e6(producer, initalValue) {
    const [s, set] = $da003f7f010eb820$export$c1e1e1ecbbe76a5(initalValue, {
        equals: false
    });
    if ("subscribe" in producer) {
        const unsub = producer.subscribe((v)=>set(()=>v));
        $da003f7f010eb820$export$b36e5eaa3e8c43ab(()=>"unsubscribe" in unsub ? unsub.unsubscribe() : unsub());
    } else {
        const clean = producer(set);
        $da003f7f010eb820$export$b36e5eaa3e8c43ab(clean);
    }
    return s;
}
const $da003f7f010eb820$var$FALLBACK = Symbol("fallback");
function $da003f7f010eb820$var$dispose(d) {
    for(let i = 0; i < d.length; i++)d[i]();
}
function $da003f7f010eb820$export$4c9116dcf1374231(list, mapFn, options = {}) {
    let items = [], mapped = [], disposers = [], len = 0, indexes = mapFn.length > 1 ? [] : null;
    $da003f7f010eb820$export$b36e5eaa3e8c43ab(()=>$da003f7f010eb820$var$dispose(disposers));
    return ()=>{
        let newItems = list() || [], newLen = newItems.length, i, j;
        newItems[$da003f7f010eb820$export$17a675b7c02a7b1d];
        return $da003f7f010eb820$export$363ebc4b78b8f807(()=>{
            let newIndices, newIndicesNext, temp, tempdisposers, tempIndexes, start, end, newEnd, item;
            if (newLen === 0) {
                if (len !== 0) {
                    $da003f7f010eb820$var$dispose(disposers);
                    disposers = [];
                    items = [];
                    mapped = [];
                    len = 0;
                    indexes && (indexes = []);
                }
                if (options.fallback) {
                    items = [
                        $da003f7f010eb820$var$FALLBACK
                    ];
                    mapped[0] = $da003f7f010eb820$export$882461b6382ed46c((disposer)=>{
                        disposers[0] = disposer;
                        return options.fallback();
                    });
                    len = 1;
                }
            } else if (len === 0) {
                mapped = new Array(newLen);
                for(j = 0; j < newLen; j++){
                    items[j] = newItems[j];
                    mapped[j] = $da003f7f010eb820$export$882461b6382ed46c(mapper);
                }
                len = newLen;
            } else {
                temp = new Array(newLen);
                tempdisposers = new Array(newLen);
                indexes && (tempIndexes = new Array(newLen));
                for(start = 0, end = Math.min(len, newLen); start < end && items[start] === newItems[start]; start++);
                for(end = len - 1, newEnd = newLen - 1; end >= start && newEnd >= start && items[end] === newItems[newEnd]; end--, newEnd--){
                    temp[newEnd] = mapped[end];
                    tempdisposers[newEnd] = disposers[end];
                    indexes && (tempIndexes[newEnd] = indexes[end]);
                }
                newIndices = new Map();
                newIndicesNext = new Array(newEnd + 1);
                for(j = newEnd; j >= start; j--){
                    item = newItems[j];
                    i = newIndices.get(item);
                    newIndicesNext[j] = i === undefined ? -1 : i;
                    newIndices.set(item, j);
                }
                for(i = start; i <= end; i++){
                    item = items[i];
                    j = newIndices.get(item);
                    if (j !== undefined && j !== -1) {
                        temp[j] = mapped[i];
                        tempdisposers[j] = disposers[i];
                        indexes && (tempIndexes[j] = indexes[i]);
                        j = newIndicesNext[j];
                        newIndices.set(item, j);
                    } else disposers[i]();
                }
                for(j = start; j < newLen; j++)if (j in temp) {
                    mapped[j] = temp[j];
                    disposers[j] = tempdisposers[j];
                    if (indexes) {
                        indexes[j] = tempIndexes[j];
                        indexes[j](j);
                    }
                } else mapped[j] = $da003f7f010eb820$export$882461b6382ed46c(mapper);
                mapped = mapped.slice(0, len = newLen);
                items = newItems.slice(0);
            }
            return mapped;
        });
        function mapper(disposer) {
            disposers[j] = disposer;
            if (indexes) {
                const [s, set] = $da003f7f010eb820$export$c1e1e1ecbbe76a5(j);
                indexes[j] = set;
                return mapFn(newItems[j], s);
            }
            return mapFn(newItems[j]);
        }
    };
}
function $da003f7f010eb820$export$2cd1c249765cd0a4(list, mapFn, options = {}) {
    let items = [], mapped = [], disposers = [], signals = [], len = 0, i;
    $da003f7f010eb820$export$b36e5eaa3e8c43ab(()=>$da003f7f010eb820$var$dispose(disposers));
    return ()=>{
        const newItems = list() || [], newLen = newItems.length;
        newItems[$da003f7f010eb820$export$17a675b7c02a7b1d];
        return $da003f7f010eb820$export$363ebc4b78b8f807(()=>{
            if (newLen === 0) {
                if (len !== 0) {
                    $da003f7f010eb820$var$dispose(disposers);
                    disposers = [];
                    items = [];
                    mapped = [];
                    len = 0;
                    signals = [];
                }
                if (options.fallback) {
                    items = [
                        $da003f7f010eb820$var$FALLBACK
                    ];
                    mapped[0] = $da003f7f010eb820$export$882461b6382ed46c((disposer)=>{
                        disposers[0] = disposer;
                        return options.fallback();
                    });
                    len = 1;
                }
                return mapped;
            }
            if (items[0] === $da003f7f010eb820$var$FALLBACK) {
                disposers[0]();
                disposers = [];
                items = [];
                mapped = [];
                len = 0;
            }
            for(i = 0; i < newLen; i++){
                if (i < items.length && items[i] !== newItems[i]) signals[i](()=>newItems[i]);
                else if (i >= items.length) mapped[i] = $da003f7f010eb820$export$882461b6382ed46c(mapper);
            }
            for(; i < items.length; i++)disposers[i]();
            len = signals.length = disposers.length = newLen;
            items = newItems.slice(0);
            return mapped = mapped.slice(0, len);
        });
        function mapper(disposer) {
            disposers[i] = disposer;
            const [s, set] = $da003f7f010eb820$export$c1e1e1ecbbe76a5(newItems[i]);
            signals[i] = set;
            return mapFn(s, i);
        }
    };
}
let $da003f7f010eb820$var$hydrationEnabled = false;
function $da003f7f010eb820$export$849801d35d2160c9() {
    $da003f7f010eb820$var$hydrationEnabled = true;
}
function $da003f7f010eb820$export$60e54eaca7e7fb38(Comp, props) {
    if ($da003f7f010eb820$var$hydrationEnabled) {
        if ($da003f7f010eb820$export$2cb4986bed338027.context) {
            const c = $da003f7f010eb820$export$2cb4986bed338027.context;
            $da003f7f010eb820$var$setHydrateContext($da003f7f010eb820$var$nextHydrateContext());
            const r = $da003f7f010eb820$export$363ebc4b78b8f807(()=>Comp(props || {}));
            $da003f7f010eb820$var$setHydrateContext(c);
            return r;
        }
    }
    return $da003f7f010eb820$export$363ebc4b78b8f807(()=>Comp(props || {}));
}
function $da003f7f010eb820$var$trueFn() {
    return true;
}
const $da003f7f010eb820$var$propTraps = {
    get (_, property, receiver) {
        if (property === $da003f7f010eb820$export$5cd89106e2f6c2c5) return receiver;
        return _.get(property);
    },
    has (_, property) {
        if (property === $da003f7f010eb820$export$5cd89106e2f6c2c5) return true;
        return _.has(property);
    },
    set: $da003f7f010eb820$var$trueFn,
    deleteProperty: $da003f7f010eb820$var$trueFn,
    getOwnPropertyDescriptor (_, property) {
        return {
            configurable: true,
            enumerable: true,
            get () {
                return _.get(property);
            },
            set: $da003f7f010eb820$var$trueFn,
            deleteProperty: $da003f7f010eb820$var$trueFn
        };
    },
    ownKeys (_) {
        return _.keys();
    }
};
function $da003f7f010eb820$var$resolveSource(s) {
    return !(s = typeof s === "function" ? s() : s) ? {} : s;
}
function $da003f7f010eb820$var$resolveSources() {
    for(let i = 0, length = this.length; i < length; ++i){
        const v = this[i]();
        if (v !== undefined) return v;
    }
}
function $da003f7f010eb820$export$9d1611c77c2fe928(...sources) {
    let proxy = false;
    for(let i = 0; i < sources.length; i++){
        const s = sources[i];
        proxy = proxy || !!s && $da003f7f010eb820$export$5cd89106e2f6c2c5 in s;
        sources[i] = typeof s === "function" ? (proxy = true, $da003f7f010eb820$export$c0c6c8b9c16bf6aa(s)) : s;
    }
    if ($da003f7f010eb820$var$SUPPORTS_PROXY && proxy) return new Proxy({
        get (property) {
            for(let i = sources.length - 1; i >= 0; i--){
                const v = $da003f7f010eb820$var$resolveSource(sources[i])[property];
                if (v !== undefined) return v;
            }
        },
        has (property) {
            for(let i = sources.length - 1; i >= 0; i--){
                if (property in $da003f7f010eb820$var$resolveSource(sources[i])) return true;
            }
            return false;
        },
        keys () {
            const keys = [];
            for(let i = 0; i < sources.length; i++)keys.push(...Object.keys($da003f7f010eb820$var$resolveSource(sources[i])));
            return [
                ...new Set(keys)
            ];
        }
    }, $da003f7f010eb820$var$propTraps);
    const sourcesMap = {};
    const defined = Object.create(null);
    for(let i = sources.length - 1; i >= 0; i--){
        const source = sources[i];
        if (!source) continue;
        const sourceKeys = Object.getOwnPropertyNames(source);
        for(let i = sourceKeys.length - 1; i >= 0; i--){
            const key = sourceKeys[i];
            if (key === "__proto__" || key === "constructor") continue;
            const desc = Object.getOwnPropertyDescriptor(source, key);
            if (!defined[key]) defined[key] = desc.get ? {
                enumerable: true,
                configurable: true,
                get: $da003f7f010eb820$var$resolveSources.bind(sourcesMap[key] = [
                    desc.get.bind(source)
                ])
            } : desc.value !== undefined ? desc : undefined;
            else {
                const sources = sourcesMap[key];
                if (sources) {
                    if (desc.get) sources.push(desc.get.bind(source));
                    else if (desc.value !== undefined) sources.push(()=>desc.value);
                }
            }
        }
    }
    const target = {};
    const definedKeys = Object.keys(defined);
    for(let i = definedKeys.length - 1; i >= 0; i--){
        const key = definedKeys[i], desc = defined[key];
        if (desc && desc.get) Object.defineProperty(target, key, desc);
        else target[key] = desc ? desc.value : undefined;
    }
    return target;
}
function $da003f7f010eb820$export$45029c61b0073d87(props, ...keys) {
    const len = keys.length;
    if ($da003f7f010eb820$var$SUPPORTS_PROXY && $da003f7f010eb820$export$5cd89106e2f6c2c5 in props) {
        const blocked = len > 1 ? keys.flat() : keys[0];
        const claimed = new Set();
        const res = keys.map((k)=>{
            const owned = k.filter((property)=>!claimed.has(property) && (claimed.add(property), true));
            return new Proxy({
                get (property) {
                    return owned.includes(property) ? props[property] : undefined;
                },
                has (property) {
                    return owned.includes(property) && property in props;
                },
                keys () {
                    return owned.filter((property)=>property in props);
                }
            }, $da003f7f010eb820$var$propTraps);
        });
        res.push(new Proxy({
            get (property) {
                return blocked.includes(property) ? undefined : props[property];
            },
            has (property) {
                return blocked.includes(property) ? false : property in props;
            },
            keys () {
                return Object.keys(props).filter((k)=>!blocked.includes(k));
            }
        }, $da003f7f010eb820$var$propTraps));
        return res;
    }
    const objects = [];
    for(let i = 0; i <= len; i++)objects[i] = {};
    for (const propName of Object.getOwnPropertyNames(props)){
        let keyIndex = len;
        for(let i = 0; i < keys.length; i++)if (keys[i].includes(propName)) {
            keyIndex = i;
            break;
        }
        const desc = Object.getOwnPropertyDescriptor(props, propName);
        const isDefaultDesc = !desc.get && !desc.set && desc.enumerable && desc.writable && desc.configurable;
        isDefaultDesc ? objects[keyIndex][propName] = desc.value : Object.defineProperty(objects[keyIndex], propName, desc);
    }
    return objects;
}
function $da003f7f010eb820$export$488013bae63b21da(fn) {
    let comp;
    let p;
    const load = ()=>{
        if (!p) {
            const cur = p = fn();
            cur.then((mod)=>{
                comp = ()=>mod.default;
            }, ()=>{
                if (p === cur) p = undefined;
            });
        }
        return p;
    };
    const wrap = (props)=>{
        const ctx = $da003f7f010eb820$export$2cb4986bed338027.context;
        if (ctx) {
            const [s, set] = $da003f7f010eb820$export$c1e1e1ecbbe76a5();
            $da003f7f010eb820$export$2cb4986bed338027.count || ($da003f7f010eb820$export$2cb4986bed338027.count = 0);
            $da003f7f010eb820$export$2cb4986bed338027.count++;
            load().then((mod)=>{
                !$da003f7f010eb820$export$2cb4986bed338027.done && $da003f7f010eb820$var$setHydrateContext(ctx);
                $da003f7f010eb820$export$2cb4986bed338027.count--;
                set(()=>mod.default);
                $da003f7f010eb820$var$setHydrateContext();
            }, (err)=>{
                !$da003f7f010eb820$export$2cb4986bed338027.done && $da003f7f010eb820$var$setHydrateContext(ctx);
                $da003f7f010eb820$export$2cb4986bed338027.count--;
                set(()=>()=>{
                        throw err;
                    });
                $da003f7f010eb820$var$setHydrateContext();
            });
            comp = s;
        } else if (!comp) {
            const [s] = $da003f7f010eb820$export$edd172c6c83c39cc(()=>load().then((mod)=>mod.default));
            comp = s;
            $da003f7f010eb820$export$b36e5eaa3e8c43ab(()=>comp = undefined);
        }
        let Comp;
        return $da003f7f010eb820$export$c0c6c8b9c16bf6aa(()=>(Comp = comp?.()) ? $da003f7f010eb820$export$363ebc4b78b8f807(()=>{
                $da003f7f010eb820$var$IS_DEV;
                if (!ctx || $da003f7f010eb820$export$2cb4986bed338027.done) return Comp(props);
                const c = $da003f7f010eb820$export$2cb4986bed338027.context;
                $da003f7f010eb820$var$setHydrateContext(ctx);
                const r = Comp(props);
                $da003f7f010eb820$var$setHydrateContext(c);
                return r;
            }) : "");
    };
    wrap.preload = ()=>load();
    return wrap;
}
let $da003f7f010eb820$var$counter = 0;
function $da003f7f010eb820$export$33208d63bc845a83() {
    const ctx = $da003f7f010eb820$export$2cb4986bed338027.context;
    return ctx ? $da003f7f010eb820$export$2cb4986bed338027.getNextContextId() : `cl-${$da003f7f010eb820$var$counter++}`;
}
const $da003f7f010eb820$var$narrowedError = (name)=>`Stale read from <${name}>.`;
function $da003f7f010eb820$export$bdf530073099ce9f(props) {
    const fallback = "fallback" in props && {
        fallback: ()=>props.fallback
    };
    return $da003f7f010eb820$export$c0c6c8b9c16bf6aa($da003f7f010eb820$export$4c9116dcf1374231(()=>props.each, props.children, fallback || undefined));
}
function $da003f7f010eb820$export$cf17b003b6192af3(props) {
    const fallback = "fallback" in props && {
        fallback: ()=>props.fallback
    };
    return $da003f7f010eb820$export$c0c6c8b9c16bf6aa($da003f7f010eb820$export$2cd1c249765cd0a4(()=>props.each, props.children, fallback || undefined));
}
function $da003f7f010eb820$export$f6a3d19be20f5819(props) {
    const keyed = props.keyed;
    const conditionValue = $da003f7f010eb820$export$c0c6c8b9c16bf6aa(()=>props.when, undefined, undefined);
    const condition = keyed ? conditionValue : $da003f7f010eb820$export$c0c6c8b9c16bf6aa(conditionValue, undefined, {
        equals: (a, b)=>!a === !b
    });
    return $da003f7f010eb820$export$c0c6c8b9c16bf6aa(()=>{
        const c = condition();
        if (c) {
            const child = props.children;
            const fn = typeof child === "function" && child.length > 0;
            return fn ? $da003f7f010eb820$export$363ebc4b78b8f807(()=>child(keyed ? c : ()=>{
                    if (!$da003f7f010eb820$export$363ebc4b78b8f807(condition)) throw $da003f7f010eb820$var$narrowedError("Show");
                    return conditionValue();
                })) : child;
        }
        return props.fallback;
    }, undefined, undefined);
}
function $da003f7f010eb820$export$b5d5cf8927ab7262(props) {
    const chs = $da003f7f010eb820$export$bacb5cc5a11aef16(()=>props.children);
    const switchFunc = $da003f7f010eb820$export$c0c6c8b9c16bf6aa(()=>{
        const ch = chs();
        const mps = Array.isArray(ch) ? ch : [
            ch
        ];
        let func = ()=>undefined;
        for(let i = 0; i < mps.length; i++){
            const index = i;
            const mp = mps[i];
            const prevFunc = func;
            const conditionValue = $da003f7f010eb820$export$c0c6c8b9c16bf6aa(()=>prevFunc() ? undefined : mp.when, undefined, undefined);
            const condition = mp.keyed ? conditionValue : $da003f7f010eb820$export$c0c6c8b9c16bf6aa(conditionValue, undefined, {
                equals: (a, b)=>!a === !b
            });
            func = ()=>prevFunc() || (condition() ? [
                    index,
                    conditionValue,
                    mp
                ] : undefined);
        }
        return func;
    });
    return $da003f7f010eb820$export$c0c6c8b9c16bf6aa(()=>{
        const sel = switchFunc()();
        if (!sel) return props.fallback;
        const [index, conditionValue, mp] = sel;
        const child = mp.children;
        const fn = typeof child === "function" && child.length > 0;
        return fn ? $da003f7f010eb820$export$363ebc4b78b8f807(()=>child(mp.keyed ? conditionValue() : ()=>{
                if ($da003f7f010eb820$export$363ebc4b78b8f807(switchFunc)()?.[0] !== index) throw $da003f7f010eb820$var$narrowedError("Match");
                return conditionValue();
            })) : child;
    }, undefined, undefined);
}
function $da003f7f010eb820$export$f421feb8fad20413(props) {
    return props;
}
let $da003f7f010eb820$var$Errors;
function $da003f7f010eb820$export$4eaee74ee7a14dca() {
    $da003f7f010eb820$var$Errors && [
        ...$da003f7f010eb820$var$Errors
    ].forEach((fn)=>fn());
}
function $da003f7f010eb820$export$e926676385687eaf(props) {
    let err;
    if ($da003f7f010eb820$export$2cb4986bed338027.context && $da003f7f010eb820$export$2cb4986bed338027.load) err = $da003f7f010eb820$export$2cb4986bed338027.load($da003f7f010eb820$export$2cb4986bed338027.getContextId());
    const [errored, setErrored] = $da003f7f010eb820$export$c1e1e1ecbbe76a5(err, undefined);
    $da003f7f010eb820$var$Errors || ($da003f7f010eb820$var$Errors = new Set());
    $da003f7f010eb820$var$Errors.add(setErrored);
    $da003f7f010eb820$export$b36e5eaa3e8c43ab(()=>$da003f7f010eb820$var$Errors.delete(setErrored));
    return $da003f7f010eb820$export$c0c6c8b9c16bf6aa(()=>{
        let e;
        if (e = errored()) {
            const f = props.fallback;
            return typeof f === "function" && f.length ? $da003f7f010eb820$export$363ebc4b78b8f807(()=>f(e, ()=>setErrored())) : f;
        }
        return $da003f7f010eb820$export$3dede90624df3ba9(()=>props.children, setErrored);
    }, undefined, undefined);
}
const $da003f7f010eb820$var$suspenseListEquals = (a, b)=>a.showContent === b.showContent && a.showFallback === b.showFallback;
const $da003f7f010eb820$var$SuspenseListContext = /* #__PURE__ */ $da003f7f010eb820$export$fd42f52fd3ae1109();
function $da003f7f010eb820$export$998bcd577473dd93(props) {
    let [wrapper, setWrapper] = $da003f7f010eb820$export$c1e1e1ecbbe76a5(()=>({
            inFallback: false
        })), show;
    const listContext = $da003f7f010eb820$export$fae74005e78b1a27($da003f7f010eb820$var$SuspenseListContext);
    const [registry, setRegistry] = $da003f7f010eb820$export$c1e1e1ecbbe76a5([]);
    if (listContext) show = listContext.register($da003f7f010eb820$export$c0c6c8b9c16bf6aa(()=>wrapper()().inFallback));
    const resolved = $da003f7f010eb820$export$c0c6c8b9c16bf6aa((prev)=>{
        const reveal = props.revealOrder, tail = props.tail, { showContent: showContent = true, showFallback: showFallback = true } = show ? show() : {}, reg = registry(), reverse = reveal === "backwards";
        if (reveal === "together") {
            const all = reg.every((inFallback)=>!inFallback());
            const res = reg.map(()=>({
                    showContent: all && showContent,
                    showFallback: showFallback
                }));
            res.inFallback = !all;
            return res;
        }
        let stop = false;
        let inFallback = prev.inFallback;
        const res = [];
        for(let i = 0, len = reg.length; i < len; i++){
            const n = reverse ? len - i - 1 : i, s = reg[n]();
            if (!stop && !s) res[n] = {
                showContent: showContent,
                showFallback: showFallback
            };
            else {
                const next = !stop;
                if (next) inFallback = true;
                res[n] = {
                    showContent: next,
                    showFallback: !tail || next && tail === "collapsed" ? showFallback : false
                };
                stop = true;
            }
        }
        if (!stop) inFallback = false;
        res.inFallback = inFallback;
        return res;
    }, {
        inFallback: false
    });
    setWrapper(()=>resolved);
    return $da003f7f010eb820$export$60e54eaca7e7fb38($da003f7f010eb820$var$SuspenseListContext.Provider, {
        value: {
            register: (inFallback)=>{
                let index;
                setRegistry((registry)=>{
                    index = registry.length;
                    return [
                        ...registry,
                        inFallback
                    ];
                });
                return $da003f7f010eb820$export$c0c6c8b9c16bf6aa(()=>resolved()[index], undefined, {
                    equals: $da003f7f010eb820$var$suspenseListEquals
                });
            }
        },
        get children () {
            return props.children;
        }
    });
}
function $da003f7f010eb820$export$74bf444e3cd11ea5(props) {
    let counter = 0, show, ctx, p, flicker, error;
    const [inFallback, setFallback] = $da003f7f010eb820$export$c1e1e1ecbbe76a5(false), SuspenseContext = $da003f7f010eb820$var$getSuspenseContext(), store = {
        increment: ()=>{
            if (++counter === 1) setFallback(true);
        },
        decrement: ()=>{
            if (--counter === 0) setFallback(false);
        },
        inFallback: inFallback,
        effects: [],
        resolved: false
    }, owner = $da003f7f010eb820$export$5f4ed0d56c2c0edf();
    if ($da003f7f010eb820$export$2cb4986bed338027.context && $da003f7f010eb820$export$2cb4986bed338027.load) {
        const key = $da003f7f010eb820$export$2cb4986bed338027.getContextId();
        let ref = $da003f7f010eb820$export$2cb4986bed338027.load(key);
        if (ref) {
            if (typeof ref !== "object" || ref.s !== 1) p = ref;
            else $da003f7f010eb820$export$2cb4986bed338027.gather(key);
        }
        if (p && p !== "$$f") {
            const [s, set] = $da003f7f010eb820$export$c1e1e1ecbbe76a5(undefined, {
                equals: false
            });
            flicker = s;
            p.then(()=>{
                if ($da003f7f010eb820$export$2cb4986bed338027.done) return set();
                $da003f7f010eb820$export$2cb4986bed338027.gather(key);
                $da003f7f010eb820$var$setHydrateContext(ctx);
                set();
                $da003f7f010eb820$var$setHydrateContext();
            }, (err)=>{
                error = err;
                set();
            });
        }
    }
    const listContext = $da003f7f010eb820$export$fae74005e78b1a27($da003f7f010eb820$var$SuspenseListContext);
    if (listContext) show = listContext.register(store.inFallback);
    let dispose;
    $da003f7f010eb820$export$b36e5eaa3e8c43ab(()=>dispose && dispose());
    return $da003f7f010eb820$export$60e54eaca7e7fb38(SuspenseContext.Provider, {
        value: store,
        get children () {
            return $da003f7f010eb820$export$c0c6c8b9c16bf6aa(()=>{
                if (error) throw error;
                ctx = $da003f7f010eb820$export$2cb4986bed338027.context;
                if (flicker) {
                    flicker();
                    return flicker = undefined;
                }
                if (ctx && p === "$$f") $da003f7f010eb820$var$setHydrateContext();
                const rendered = $da003f7f010eb820$export$c0c6c8b9c16bf6aa(()=>props.children);
                return $da003f7f010eb820$export$c0c6c8b9c16bf6aa((prev)=>{
                    const inFallback = store.inFallback(), { showContent: showContent = true, showFallback: showFallback = true } = show ? show() : {};
                    if ((!inFallback || p && p !== "$$f") && showContent) {
                        store.resolved = true;
                        dispose && dispose();
                        dispose = ctx = p = undefined;
                        $da003f7f010eb820$var$resumeEffects(store.effects);
                        return rendered();
                    }
                    if (!showFallback) return;
                    if (dispose) return prev;
                    return $da003f7f010eb820$export$882461b6382ed46c((disposer)=>{
                        dispose = disposer;
                        if (ctx) {
                            $da003f7f010eb820$var$setHydrateContext({
                                id: ctx.id + "F",
                                count: 0
                            });
                            ctx = undefined;
                        }
                        return props.fallback;
                    }, owner);
                });
            });
        }
    });
}
const $da003f7f010eb820$export$404582bc18fe4d9e = undefined;

});

parcelRegister("dQeAa", function(module, exports) {

$parcel$export(module.exports, "memo", () => $a13b7177169dd23a$export$7c73462e0d25e514);
$parcel$export(module.exports, "render", () => $a13b7177169dd23a$export$b3890eb0ae9dca99);
$parcel$export(module.exports, "insert", () => $a13b7177169dd23a$export$21a5ca8aa77d35ff);
$parcel$export(module.exports, "template", () => $a13b7177169dd23a$export$ce69bd05624d0c48);
$parcel$export(module.exports, "delegateEvents", () => $a13b7177169dd23a$export$ad0f7f87f67e17d6);
$parcel$export(module.exports, "setAttribute", () => $a13b7177169dd23a$export$9fec4d97f1922e0b);
$parcel$export(module.exports, "className", () => $a13b7177169dd23a$export$2913c0c0b5623090);
$parcel$export(module.exports, "use", () => $a13b7177169dd23a$export$1f96ae73734a86cc);
$parcel$export(module.exports, "effect", () => (parcelRequire("iIpFz")).createRenderEffect);

var $iIpFz = parcelRequire("iIpFz");
const $a13b7177169dd23a$var$booleans = [
    "allowfullscreen",
    "async",
    "alpha",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "disabled",
    "formnovalidate",
    "hidden",
    "indeterminate",
    "inert",
    "ismap",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "seamless",
    "selected",
    "adauctionheaders",
    "browsingtopics",
    "credentialless",
    "defaultchecked",
    "defaultmuted",
    "defaultselected",
    "defer",
    "disablepictureinpicture",
    "disableremoteplayback",
    "preservespitch",
    "shadowrootclonable",
    "shadowrootcustomelementregistry",
    "shadowrootdelegatesfocus",
    "shadowrootserializable",
    "sharedstoragewritable"
];
const $a13b7177169dd23a$export$8714badcfa4caafb = /*#__PURE__*/ new Set([
    "className",
    "value",
    "readOnly",
    "noValidate",
    "formNoValidate",
    "isMap",
    "noModule",
    "playsInline",
    "adAuctionHeaders",
    "allowFullscreen",
    "browsingTopics",
    "defaultChecked",
    "defaultMuted",
    "defaultSelected",
    "disablePictureInPicture",
    "disableRemotePlayback",
    "preservesPitch",
    "shadowRootClonable",
    "shadowRootCustomElementRegistry",
    "shadowRootDelegatesFocus",
    "shadowRootSerializable",
    "sharedStorageWritable",
    ...$a13b7177169dd23a$var$booleans
]);
const $a13b7177169dd23a$export$2c72a9edec54d5d9 = /*#__PURE__*/ new Set([
    "innerHTML",
    "textContent",
    "innerText",
    "children"
]);
const $a13b7177169dd23a$export$8915b7db7f70cfed = /*#__PURE__*/ Object.assign(Object.create(null), {
    className: "class",
    htmlFor: "for"
});
const $a13b7177169dd23a$var$PropAliases = /*#__PURE__*/ Object.assign(Object.create(null), {
    class: "className",
    novalidate: {
        $: "noValidate",
        FORM: 1
    },
    formnovalidate: {
        $: "formNoValidate",
        BUTTON: 1,
        INPUT: 1
    },
    ismap: {
        $: "isMap",
        IMG: 1
    },
    nomodule: {
        $: "noModule",
        SCRIPT: 1
    },
    playsinline: {
        $: "playsInline",
        VIDEO: 1
    },
    readonly: {
        $: "readOnly",
        INPUT: 1,
        TEXTAREA: 1
    },
    adauctionheaders: {
        $: "adAuctionHeaders",
        IFRAME: 1
    },
    allowfullscreen: {
        $: "allowFullscreen",
        IFRAME: 1
    },
    browsingtopics: {
        $: "browsingTopics",
        IMG: 1
    },
    defaultchecked: {
        $: "defaultChecked",
        INPUT: 1
    },
    defaultmuted: {
        $: "defaultMuted",
        AUDIO: 1,
        VIDEO: 1
    },
    defaultselected: {
        $: "defaultSelected",
        OPTION: 1
    },
    disablepictureinpicture: {
        $: "disablePictureInPicture",
        VIDEO: 1
    },
    disableremoteplayback: {
        $: "disableRemotePlayback",
        AUDIO: 1,
        VIDEO: 1
    },
    preservespitch: {
        $: "preservesPitch",
        AUDIO: 1,
        VIDEO: 1
    },
    shadowrootclonable: {
        $: "shadowRootClonable",
        TEMPLATE: 1
    },
    shadowrootdelegatesfocus: {
        $: "shadowRootDelegatesFocus",
        TEMPLATE: 1
    },
    shadowrootserializable: {
        $: "shadowRootSerializable",
        TEMPLATE: 1
    },
    sharedstoragewritable: {
        $: "sharedStorageWritable",
        IFRAME: 1,
        IMG: 1
    }
});
function $a13b7177169dd23a$export$72dcdd3761a309a9(prop, tagName) {
    const a = $a13b7177169dd23a$var$PropAliases[prop];
    return typeof a === "object" ? a[tagName] ? a["$"] : undefined : a;
}
const $a13b7177169dd23a$export$389d7c657d123a81 = /*#__PURE__*/ new Set([
    "beforeinput",
    "click",
    "dblclick",
    "contextmenu",
    "focusin",
    "focusout",
    "input",
    "keydown",
    "keyup",
    "mousedown",
    "mousemove",
    "mouseout",
    "mouseover",
    "mouseup",
    "pointerdown",
    "pointermove",
    "pointerout",
    "pointerover",
    "pointerup",
    "touchend",
    "touchmove",
    "touchstart"
]);
const $a13b7177169dd23a$export$ccaf9b9a82de4b98 = /*#__PURE__*/ new Set([
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animate",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "circle",
    "clipPath",
    "color-profile",
    "cursor",
    "defs",
    "desc",
    "ellipse",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "filter",
    "font",
    "font-face",
    "font-face-format",
    "font-face-name",
    "font-face-src",
    "font-face-uri",
    "foreignObject",
    "g",
    "glyph",
    "glyphRef",
    "hkern",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "metadata",
    "missing-glyph",
    "mpath",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "set",
    "stop",
    "svg",
    "switch",
    "symbol",
    "text",
    "textPath",
    "tref",
    "tspan",
    "use",
    "view",
    "vkern"
]);
const $a13b7177169dd23a$export$fa927d1d0495a67d = {
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace"
};
const $a13b7177169dd23a$export$87d0e790667228e9 = /*#__PURE__*/ new Set([
    "html",
    "base",
    "head",
    "link",
    "meta",
    "style",
    "title",
    "body",
    "address",
    "article",
    "aside",
    "footer",
    "header",
    "main",
    "nav",
    "section",
    "body",
    "blockquote",
    "dd",
    "div",
    "dl",
    "dt",
    "figcaption",
    "figure",
    "hr",
    "li",
    "ol",
    "p",
    "pre",
    "ul",
    "a",
    "abbr",
    "b",
    "bdi",
    "bdo",
    "br",
    "cite",
    "code",
    "data",
    "dfn",
    "em",
    "i",
    "kbd",
    "mark",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "small",
    "span",
    "strong",
    "sub",
    "sup",
    "time",
    "u",
    "var",
    "wbr",
    "area",
    "audio",
    "img",
    "map",
    "track",
    "video",
    "embed",
    "iframe",
    "object",
    "param",
    "picture",
    "portal",
    "source",
    "svg",
    "math",
    "canvas",
    "noscript",
    "script",
    "del",
    "ins",
    "caption",
    "col",
    "colgroup",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "tr",
    "button",
    "datalist",
    "fieldset",
    "form",
    "input",
    "label",
    "legend",
    "meter",
    "optgroup",
    "option",
    "output",
    "progress",
    "select",
    "textarea",
    "details",
    "dialog",
    "menu",
    "summary",
    "details",
    "slot",
    "template",
    "acronym",
    "applet",
    "basefont",
    "bgsound",
    "big",
    "blink",
    "center",
    "content",
    "dir",
    "font",
    "frame",
    "frameset",
    "hgroup",
    "image",
    "keygen",
    "marquee",
    "menuitem",
    "nobr",
    "noembed",
    "noframes",
    "plaintext",
    "rb",
    "rtc",
    "shadow",
    "spacer",
    "strike",
    "tt",
    "xmp",
    "a",
    "abbr",
    "acronym",
    "address",
    "applet",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "basefont",
    "bdi",
    "bdo",
    "bgsound",
    "big",
    "blink",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "center",
    "cite",
    "code",
    "col",
    "colgroup",
    "content",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "font",
    "footer",
    "form",
    "frame",
    "frameset",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "image",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "nobr",
    "noembed",
    "noframes",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "plaintext",
    "portal",
    "pre",
    "progress",
    "q",
    "rb",
    "rp",
    "rt",
    "rtc",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "shadow",
    "slot",
    "small",
    "source",
    "spacer",
    "span",
    "strike",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "template",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "tt",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "xmp",
    "input",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "webview",
    "isindex",
    "listing",
    "multicol",
    "nextid",
    "noindex",
    "search"
]);
const $a13b7177169dd23a$export$7c73462e0d25e514 = (fn)=>(0, $iIpFz.createMemo)(()=>fn());
function $a13b7177169dd23a$var$reconcileArrays(parentNode, a, b) {
    let bLength = b.length, aEnd = a.length, bEnd = bLength, aStart = 0, bStart = 0, after = a[aEnd - 1].nextSibling, map = null;
    while(aStart < aEnd || bStart < bEnd){
        if (a[aStart] === b[bStart]) {
            aStart++;
            bStart++;
            continue;
        }
        while(a[aEnd - 1] === b[bEnd - 1]){
            aEnd--;
            bEnd--;
        }
        if (aEnd === aStart) {
            const node = bEnd < bLength ? bStart ? b[bStart - 1].nextSibling : b[bEnd - bStart] : after;
            while(bStart < bEnd)parentNode.insertBefore(b[bStart++], node);
        } else if (bEnd === bStart) while(aStart < aEnd){
            if (!map || !map.has(a[aStart])) a[aStart].remove();
            aStart++;
        }
        else if (a[aStart] === b[bEnd - 1] && b[bStart] === a[aEnd - 1]) {
            const node = a[--aEnd].nextSibling;
            parentNode.insertBefore(b[bStart++], a[aStart++].nextSibling);
            parentNode.insertBefore(b[--bEnd], node);
            a[aEnd] = b[bEnd];
        } else {
            if (!map) {
                map = new Map();
                let i = bStart;
                while(i < bEnd)map.set(b[i], i++);
            }
            const index = map.get(a[aStart]);
            if (index != null) {
                if (bStart < index && index < bEnd) {
                    let i = aStart, sequence = 1, t;
                    while(++i < aEnd && i < bEnd){
                        if ((t = map.get(a[i])) == null || t !== index + sequence) break;
                        sequence++;
                    }
                    if (sequence > index - bStart) {
                        const node = a[aStart];
                        while(bStart < index)parentNode.insertBefore(b[bStart++], node);
                    } else parentNode.replaceChild(b[bStart++], a[aStart++]);
                } else aStart++;
            } else a[aStart++].remove();
        }
    }
}
const $a13b7177169dd23a$var$$$EVENTS = "_$DX_DELEGATE";
function $a13b7177169dd23a$export$b3890eb0ae9dca99(code, element, init, options = {}) {
    let disposer;
    (0, $iIpFz.createRoot)((dispose)=>{
        disposer = dispose;
        element === document ? code() : $a13b7177169dd23a$export$21a5ca8aa77d35ff(element, code(), !init && element.firstChild ? null : undefined, init);
    }, options.owner);
    return ()=>{
        disposer();
        element.textContent = "";
    };
}
function $a13b7177169dd23a$export$ce69bd05624d0c48(html, isImportNode, isSVG, isMathML) {
    let node;
    const create = ()=>{
        const t = isMathML ? document.createElementNS("http://www.w3.org/1998/Math/MathML", "template") : document.createElement("template");
        t.innerHTML = html;
        return isSVG ? t.content.firstChild.firstChild : isMathML ? t.firstChild : t.content.firstChild;
    };
    const fn = isImportNode ? ()=>(0, $iIpFz.untrack)(()=>document.importNode(node || (node = create()), true)) : ()=>(node || (node = create())).cloneNode(true);
    fn.cloneNode = fn;
    return fn;
}
function $a13b7177169dd23a$export$ad0f7f87f67e17d6(eventNames, document1 = window.document) {
    const e = document1[$a13b7177169dd23a$var$$$EVENTS] || (document1[$a13b7177169dd23a$var$$$EVENTS] = new Set());
    for(let i = 0, l = eventNames.length; i < l; i++){
        const name = eventNames[i];
        if (!e.has(name)) {
            e.add(name);
            document1.addEventListener(name, $a13b7177169dd23a$var$eventHandler);
        }
    }
}
function $a13b7177169dd23a$export$aedd29ca2033b694(document1 = window.document) {
    if (document1[$a13b7177169dd23a$var$$$EVENTS]) {
        for (let name of document1[$a13b7177169dd23a$var$$$EVENTS].keys())document1.removeEventListener(name, $a13b7177169dd23a$var$eventHandler);
        delete document1[$a13b7177169dd23a$var$$$EVENTS];
    }
}
function $a13b7177169dd23a$export$a41c68a4eb5ff164(node, name, value) {
    if ($a13b7177169dd23a$var$isHydrating(node)) return;
    if ((name === "value" || name === "defaultValue") && (node.nodeName === "INPUT" || node.nodeName === "TEXTAREA")) node[name] = value ?? "";
    else node[name] = value;
}
function $a13b7177169dd23a$export$9fec4d97f1922e0b(node, name, value) {
    if ($a13b7177169dd23a$var$isHydrating(node)) return;
    if (value == null) node.removeAttribute(name);
    else node.setAttribute(name, value);
}
function $a13b7177169dd23a$export$75900142c9e21800(node, namespace, name, value) {
    if ($a13b7177169dd23a$var$isHydrating(node)) return;
    if (value == null) node.removeAttributeNS(namespace, name);
    else node.setAttributeNS(namespace, name, value);
}
function $a13b7177169dd23a$export$248913d9a30bef7a(node, name, value) {
    if ($a13b7177169dd23a$var$isHydrating(node)) return;
    value ? node.setAttribute(name, "") : node.removeAttribute(name);
}
function $a13b7177169dd23a$export$2913c0c0b5623090(node, value) {
    if ($a13b7177169dd23a$var$isHydrating(node)) return;
    if (value == null) node.removeAttribute("class");
    else node.className = value;
}
function $a13b7177169dd23a$export$3f65cefe8380dbea(node, name, handler, delegate) {
    if (delegate) {
        if (Array.isArray(handler)) {
            node[`$$${name}`] = handler[0];
            node[`$$${name}Data`] = handler[1];
        } else node[`$$${name}`] = handler;
    } else if (Array.isArray(handler)) {
        const handlerFn = handler[0];
        node.addEventListener(name, handler[0] = (e)=>handlerFn.call(node, handler[1], e));
    } else node.addEventListener(name, handler, typeof handler !== "function" && handler);
}
function $a13b7177169dd23a$export$11c615ce16f87241(node, value, prev = {}) {
    const classKeys = Object.keys(value || {}), prevKeys = Object.keys(prev);
    let i, len;
    for(i = 0, len = prevKeys.length; i < len; i++){
        const key = prevKeys[i];
        if (!key || key === "undefined" || value[key]) continue;
        $a13b7177169dd23a$var$toggleClassKey(node, key, false);
        delete prev[key];
    }
    for(i = 0, len = classKeys.length; i < len; i++){
        const key = classKeys[i], classValue = !!value[key];
        if (!key || key === "undefined" || prev[key] === classValue || !classValue) continue;
        $a13b7177169dd23a$var$toggleClassKey(node, key, true);
        prev[key] = classValue;
    }
    return prev;
}
function $a13b7177169dd23a$export$1d567c320f4763bc(node, value, prev) {
    if (!value) return prev ? $a13b7177169dd23a$export$9fec4d97f1922e0b(node, "style") : value;
    const nodeStyle = node.style;
    if (typeof value === "string") return nodeStyle.cssText = value;
    typeof prev === "string" && (nodeStyle.cssText = prev = undefined);
    prev || (prev = {});
    value || (value = {});
    let v, s;
    for(s in prev){
        value[s] == null && nodeStyle.removeProperty(s);
        delete prev[s];
    }
    for(s in value){
        v = value[s];
        if (v !== prev[s]) {
            nodeStyle.setProperty(s, v);
            prev[s] = v;
        }
    }
    return prev;
}
function $a13b7177169dd23a$export$36a7c0615a5a1a31(node, name, value) {
    value != null ? node.style.setProperty(name, value) : node.style.removeProperty(name);
}
function $a13b7177169dd23a$export$3ae0fd4797ed47c8(node, props = {}, isSVG, skipChildren) {
    const prevProps = {};
    if (!skipChildren) (0, $iIpFz.createRenderEffect)(()=>prevProps.children = $a13b7177169dd23a$var$insertExpression(node, props.children, prevProps.children));
    (0, $iIpFz.createRenderEffect)(()=>typeof props.ref === "function" && $a13b7177169dd23a$export$1f96ae73734a86cc(props.ref, node));
    (0, $iIpFz.createRenderEffect)(()=>$a13b7177169dd23a$export$e6e34fd1f2686227(node, props, isSVG, true, prevProps, true));
    return prevProps;
}
function $a13b7177169dd23a$export$2810486c22c942e9(props, key) {
    const src = props[key];
    Object.defineProperty(props, key, {
        get () {
            return src();
        },
        enumerable: true
    });
    return props;
}
function $a13b7177169dd23a$export$1f96ae73734a86cc(fn, element, arg) {
    return (0, $iIpFz.untrack)(()=>fn(element, arg));
}
function $a13b7177169dd23a$export$21a5ca8aa77d35ff(parent, accessor, marker, initial) {
    if (marker !== undefined && !initial) initial = [];
    if (typeof accessor !== "function") return $a13b7177169dd23a$var$insertExpression(parent, accessor, initial, marker);
    (0, $iIpFz.createRenderEffect)((current)=>$a13b7177169dd23a$var$insertExpression(parent, accessor(), current, marker), initial);
}
function $a13b7177169dd23a$export$e6e34fd1f2686227(node, props, isSVG, skipChildren, prevProps = {}, skipRef = false) {
    props || (props = {});
    for(const prop in prevProps)if (!(prop in props)) {
        if (prop === "children") continue;
        prevProps[prop] = $a13b7177169dd23a$var$assignProp(node, prop, null, prevProps[prop], isSVG, skipRef, props);
    }
    for(const prop in props){
        if (prop === "children") {
            if (!skipChildren) $a13b7177169dd23a$var$insertExpression(node, props.children);
            continue;
        }
        const value = props[prop];
        prevProps[prop] = $a13b7177169dd23a$var$assignProp(node, prop, value, prevProps[prop], isSVG, skipRef, props);
    }
}
function $a13b7177169dd23a$var$hydrate$1(code, element, options = {}) {
    if (globalThis._$HY.done) return $a13b7177169dd23a$export$b3890eb0ae9dca99(code, element, [
        ...element.childNodes
    ], options);
    (0, $iIpFz.sharedConfig).completed = globalThis._$HY.completed;
    (0, $iIpFz.sharedConfig).events = globalThis._$HY.events;
    (0, $iIpFz.sharedConfig).load = (id)=>globalThis._$HY.r[id];
    (0, $iIpFz.sharedConfig).has = (id)=>id in globalThis._$HY.r;
    (0, $iIpFz.sharedConfig).gather = (root)=>$a13b7177169dd23a$var$gatherHydratable(element, root);
    (0, $iIpFz.sharedConfig).registry = new Map();
    (0, $iIpFz.sharedConfig).context = {
        id: options.renderId || "",
        count: 0
    };
    try {
        $a13b7177169dd23a$var$gatherHydratable(element, options.renderId);
        return $a13b7177169dd23a$export$b3890eb0ae9dca99(code, element, [
            ...element.childNodes
        ], options);
    } finally{
        (0, $iIpFz.sharedConfig).context = null;
    }
}
function $a13b7177169dd23a$export$4109ed81edd7716d(template) {
    let node, key, hydrating = $a13b7177169dd23a$var$isHydrating();
    if (!hydrating || !(node = (0, $iIpFz.sharedConfig).registry.get(key = $a13b7177169dd23a$export$a5a9dff0691837de()))) return template();
    if ((0, $iIpFz.sharedConfig).completed) (0, $iIpFz.sharedConfig).completed.add(node);
    (0, $iIpFz.sharedConfig).registry.delete(key);
    return node;
}
function $a13b7177169dd23a$export$c19731b2c49ee4c9(el, nodeName) {
    while(el && el.localName !== nodeName)el = el.nextSibling;
    return el;
}
function $a13b7177169dd23a$export$5cf9b6f37b7c0802(start) {
    let end = start, count = 0, current = [];
    if ($a13b7177169dd23a$var$isHydrating(start)) while(end){
        if (end.nodeType === 8) {
            const v = end.nodeValue;
            if (v === "$") count++;
            else if (v === "/") {
                if (count === 0) return [
                    end,
                    current
                ];
                count--;
            }
        }
        current.push(end);
        end = end.nextSibling;
    }
    return [
        end,
        current
    ];
}
function $a13b7177169dd23a$export$6fef5763b6d3688d() {
    if ((0, $iIpFz.sharedConfig).events && !(0, $iIpFz.sharedConfig).events.queued) {
        queueMicrotask(()=>{
            const { completed: completed, events: events } = (0, $iIpFz.sharedConfig);
            if (!events) return;
            events.queued = false;
            while(events.length){
                const [el, e] = events[0];
                if (!completed.has(el)) return;
                events.shift();
                $a13b7177169dd23a$var$eventHandler(e);
            }
            if ((0, $iIpFz.sharedConfig).done) {
                (0, $iIpFz.sharedConfig).events = _$HY.events = null;
                (0, $iIpFz.sharedConfig).completed = _$HY.completed = null;
            }
        });
        (0, $iIpFz.sharedConfig).events.queued = true;
    }
}
function $a13b7177169dd23a$var$isHydrating(node) {
    return !!(0, $iIpFz.sharedConfig).context && !(0, $iIpFz.sharedConfig).done && (!node || node.isConnected);
}
function $a13b7177169dd23a$var$toPropertyName(name) {
    return name.toLowerCase().replace(/-([a-z])/g, (_, w)=>w.toUpperCase());
}
function $a13b7177169dd23a$var$toggleClassKey(node, key, value) {
    const classNames = key.trim().split(/\s+/);
    for(let i = 0, nameLen = classNames.length; i < nameLen; i++)node.classList.toggle(classNames[i], value);
}
function $a13b7177169dd23a$var$assignProp(node, prop, value, prev, isSVG, skipRef, props) {
    let isCE, isProp, isChildProp, propAlias, forceProp;
    if (prop === "style") return $a13b7177169dd23a$export$1d567c320f4763bc(node, value, prev);
    if (prop === "classList") return $a13b7177169dd23a$export$11c615ce16f87241(node, value, prev);
    if (value === prev) return prev;
    if (prop === "ref") {
        if (!skipRef) value(node);
    } else if (prop.slice(0, 3) === "on:") {
        const e = prop.slice(3);
        prev && node.removeEventListener(e, prev, typeof prev !== "function" && prev);
        value && node.addEventListener(e, value, typeof value !== "function" && value);
    } else if (prop.slice(0, 10) === "oncapture:") {
        const e = prop.slice(10);
        prev && node.removeEventListener(e, prev, true);
        value && node.addEventListener(e, value, true);
    } else if (prop.slice(0, 2) === "on") {
        const name = prop.slice(2).toLowerCase();
        const delegate = $a13b7177169dd23a$export$389d7c657d123a81.has(name);
        if (!delegate && prev) {
            const h = Array.isArray(prev) ? prev[0] : prev;
            node.removeEventListener(name, h);
        }
        if (delegate || value) {
            $a13b7177169dd23a$export$3f65cefe8380dbea(node, name, value, delegate);
            delegate && $a13b7177169dd23a$export$ad0f7f87f67e17d6([
                name
            ]);
        }
    } else if (prop.slice(0, 5) === "attr:") $a13b7177169dd23a$export$9fec4d97f1922e0b(node, prop.slice(5), value);
    else if (prop.slice(0, 5) === "bool:") $a13b7177169dd23a$export$248913d9a30bef7a(node, prop.slice(5), value);
    else if ((forceProp = prop.slice(0, 5) === "prop:") || (isChildProp = $a13b7177169dd23a$export$2c72a9edec54d5d9.has(prop)) || !isSVG && ((propAlias = $a13b7177169dd23a$export$72dcdd3761a309a9(prop, node.tagName)) || (isProp = $a13b7177169dd23a$export$8714badcfa4caafb.has(prop))) || (isCE = node.nodeName.includes("-") || "is" in props)) {
        if (forceProp) {
            prop = prop.slice(5);
            isProp = true;
        } else if ($a13b7177169dd23a$var$isHydrating(node)) return value;
        if (prop === "class" || prop === "className") $a13b7177169dd23a$export$2913c0c0b5623090(node, value);
        else if (isCE && !isProp && !isChildProp) node[$a13b7177169dd23a$var$toPropertyName(prop)] = value;
        else if ((prop === "value" || prop === "defaultValue") && (node.nodeName === "INPUT" || node.nodeName === "TEXTAREA")) node[propAlias || prop] = value ?? "";
        else node[propAlias || prop] = value;
    } else {
        const ns = isSVG && prop.indexOf(":") > -1 && $a13b7177169dd23a$export$fa927d1d0495a67d[prop.split(":")[0]];
        if (ns) $a13b7177169dd23a$export$75900142c9e21800(node, ns, prop, value);
        else $a13b7177169dd23a$export$9fec4d97f1922e0b(node, $a13b7177169dd23a$export$8915b7db7f70cfed[prop] || prop, value);
    }
    return value;
}
function $a13b7177169dd23a$var$eventHandler(e) {
    if ((0, $iIpFz.sharedConfig).registry && (0, $iIpFz.sharedConfig).events) {
        if ((0, $iIpFz.sharedConfig).events.find(([el, ev])=>ev === e)) return;
    }
    let node = e.target;
    const key = `$$${e.type}`;
    const oriTarget = e.target;
    const oriCurrentTarget = e.currentTarget;
    const retarget = (value)=>Object.defineProperty(e, "target", {
            configurable: true,
            value: value
        });
    const handleNode = ()=>{
        const handler = node[key];
        if (handler && !node.disabled) {
            const data = node[`${key}Data`];
            data !== undefined ? handler.call(node, data, e) : handler.call(node, e);
            if (e.cancelBubble) return;
        }
        node.host && typeof node.host !== "string" && !node.host._$host && node.contains(e.target) && retarget(node.host);
        return true;
    };
    const walkUpTree = ()=>{
        while(handleNode() && (node = node._$host || node.parentNode || node.host));
    };
    Object.defineProperty(e, "currentTarget", {
        configurable: true,
        get () {
            return node || document;
        }
    });
    if ((0, $iIpFz.sharedConfig).registry && !(0, $iIpFz.sharedConfig).done) (0, $iIpFz.sharedConfig).done = _$HY.done = true;
    try {
        if (e.composedPath) {
            const path = e.composedPath();
            retarget(path[0]);
            for(let i = 0; i < path.length - 2; i++){
                node = path[i];
                if (!handleNode()) break;
                if (node._$host) {
                    node = node._$host;
                    walkUpTree();
                    break;
                }
                if (node.parentNode === oriCurrentTarget) break;
            }
        } else walkUpTree();
        retarget(oriTarget);
    } finally{
        e = node = null;
    }
}
function $a13b7177169dd23a$var$insertExpression(parent, value, current, marker, unwrapArray) {
    const hydrating = $a13b7177169dd23a$var$isHydrating(parent);
    if (hydrating) {
        !current && (current = [
            ...parent.childNodes
        ]);
        let cleaned = [];
        for(let i = 0; i < current.length; i++){
            const node = current[i];
            if (node.nodeType === 8 && node.data.slice(0, 2) === "!$") node.remove();
            else cleaned.push(node);
        }
        current = cleaned;
    }
    while(typeof current === "function")current = current();
    if (value === current) return current;
    const t = typeof value, multi = marker !== undefined;
    parent = multi && current[0] && current[0].parentNode || parent;
    if (t === "string" || t === "number") {
        if (hydrating) return current;
        if (t === "number") {
            value = value.toString();
            if (value === current) return current;
        }
        if (multi) {
            let node = current[0];
            if (node && node.nodeType === 3) node.data !== value && (node.data = value);
            else node = document.createTextNode(value);
            current = $a13b7177169dd23a$var$cleanChildren(parent, current, marker, node);
        } else if (current !== "" && typeof current === "string") current = parent.firstChild.data = value;
        else current = parent.textContent = value;
    } else if (value == null || t === "boolean") {
        if (hydrating) return current;
        current = $a13b7177169dd23a$var$cleanChildren(parent, current, marker);
    } else if (t === "function") {
        (0, $iIpFz.createRenderEffect)(()=>{
            let v = value();
            while(typeof v === "function")v = v();
            current = $a13b7177169dd23a$var$insertExpression(parent, v, current, marker);
        });
        return ()=>current;
    } else if (Array.isArray(value)) {
        const array = [];
        const currentArray = current && Array.isArray(current);
        if ($a13b7177169dd23a$var$normalizeIncomingArray(array, value, current, unwrapArray)) {
            (0, $iIpFz.createRenderEffect)(()=>current = $a13b7177169dd23a$var$insertExpression(parent, array, current, marker, true));
            return ()=>current;
        }
        if (hydrating) {
            if (!array.length) return current;
            if (marker === undefined) return current = [
                ...parent.childNodes
            ];
            let node = array[0];
            if (node.parentNode !== parent) return current;
            const nodes = [
                node
            ];
            while((node = node.nextSibling) !== marker)nodes.push(node);
            return current = nodes;
        }
        if (array.length === 0) {
            current = $a13b7177169dd23a$var$cleanChildren(parent, current, marker);
            if (multi) return current;
        } else if (currentArray) {
            if (current.length === 0) $a13b7177169dd23a$var$appendNodes(parent, array, marker);
            else $a13b7177169dd23a$var$reconcileArrays(parent, current, array);
        } else {
            current && $a13b7177169dd23a$var$cleanChildren(parent);
            $a13b7177169dd23a$var$appendNodes(parent, array);
        }
        current = array;
    } else if (value.nodeType) {
        if (hydrating && value.parentNode) return current = multi ? [
            value
        ] : value;
        if (Array.isArray(current)) {
            if (multi) return current = $a13b7177169dd23a$var$cleanChildren(parent, current, marker, value);
            $a13b7177169dd23a$var$cleanChildren(parent, current, null, value);
        } else if (current == null || current === "" || !parent.firstChild) parent.appendChild(value);
        else parent.replaceChild(value, parent.firstChild);
        current = value;
    }
    return current;
}
function $a13b7177169dd23a$var$normalizeIncomingArray(normalized, array, current, unwrap) {
    let dynamic = false;
    for(let i = 0, len = array.length; i < len; i++){
        let item = array[i], prev = current && current[normalized.length], t;
        if (item == null || item === true || item === false) ;
        else if ((t = typeof item) === "object" && item.nodeType) normalized.push(item);
        else if (Array.isArray(item)) dynamic = $a13b7177169dd23a$var$normalizeIncomingArray(normalized, item, prev) || dynamic;
        else if (t === "function") {
            if (unwrap) {
                while(typeof item === "function")item = item();
                dynamic = $a13b7177169dd23a$var$normalizeIncomingArray(normalized, Array.isArray(item) ? item : [
                    item
                ], Array.isArray(prev) ? prev : [
                    prev
                ]) || dynamic;
            } else {
                normalized.push(item);
                dynamic = true;
            }
        } else {
            const value = String(item);
            if (prev && prev.nodeType === 3 && prev.data === value) normalized.push(prev);
            else normalized.push(document.createTextNode(value));
        }
    }
    return dynamic;
}
function $a13b7177169dd23a$var$appendNodes(parent, array, marker = null) {
    for(let i = 0, len = array.length; i < len; i++)parent.insertBefore(array[i], marker);
}
function $a13b7177169dd23a$var$cleanChildren(parent, current, marker, replacement) {
    if (marker === undefined) return parent.textContent = "";
    const node = replacement || document.createTextNode("");
    if (current.length) {
        let inserted = false;
        for(let i = current.length - 1; i >= 0; i--){
            const el = current[i];
            if (node !== el) {
                const isParent = el.parentNode === parent;
                if (!inserted && !i) isParent ? parent.replaceChild(node, el) : parent.insertBefore(node, marker);
                else isParent && el.remove();
            } else inserted = true;
        }
    } else parent.insertBefore(node, marker);
    return [
        node
    ];
}
function $a13b7177169dd23a$var$gatherHydratable(element, root) {
    const templates = element.querySelectorAll(`*[data-hk]`);
    for(let i = 0; i < templates.length; i++){
        const node = templates[i];
        const key = node.getAttribute("data-hk");
        if ((!root || key.startsWith(root)) && !(0, $iIpFz.sharedConfig).registry.has(key)) (0, $iIpFz.sharedConfig).registry.set(key, node);
    }
}
function $a13b7177169dd23a$export$a5a9dff0691837de() {
    return (0, $iIpFz.sharedConfig).getNextContextId();
}
function $a13b7177169dd23a$export$36143b7c9c07dd39(props) {
    return (0, $iIpFz.sharedConfig).context ? undefined : props.children;
}
function $a13b7177169dd23a$export$da8cca6e5dfa3577(props) {
    return props.children;
}
const $a13b7177169dd23a$export$c8eca95e306f7116 = ()=>undefined;
const $a13b7177169dd23a$export$5df49ba75ba1c1f9 = Symbol();
function $a13b7177169dd23a$export$8bd3fff6c675ca8d(parent, content) {
    !(0, $iIpFz.sharedConfig).context && (parent.innerHTML = content);
}
function $a13b7177169dd23a$var$throwInBrowser(func) {
    const err = new Error(`${func.name} is not supported in the browser, returning undefined`);
    console.error(err);
}
function $a13b7177169dd23a$export$80e7718417253a51(fn, options) {
    $a13b7177169dd23a$var$throwInBrowser($a13b7177169dd23a$export$80e7718417253a51);
}
function $a13b7177169dd23a$export$f3aefc4196cd5f3e(fn, options) {
    $a13b7177169dd23a$var$throwInBrowser($a13b7177169dd23a$export$f3aefc4196cd5f3e);
}
function $a13b7177169dd23a$export$97f86213fef5749d(fn, options) {
    $a13b7177169dd23a$var$throwInBrowser($a13b7177169dd23a$export$97f86213fef5749d);
}
function $a13b7177169dd23a$export$ea2375f6c0c9ffdc(template, ...nodes) {}
function $a13b7177169dd23a$export$1844beb7faeb4553(name, props, children, needsId) {}
function $a13b7177169dd23a$export$e92e0c287593a882(value) {}
function $a13b7177169dd23a$export$9e97f11b9d683d7a(value) {}
function $a13b7177169dd23a$export$9ab8bdc1e27e51e1(key, value) {}
function $a13b7177169dd23a$export$7e66a08c0b8ab2aa() {}
function $a13b7177169dd23a$export$755e9f954b4fd36e(node) {}
function $a13b7177169dd23a$export$4e7f196112fea3c5(html) {}
function $a13b7177169dd23a$export$8c2b042ce8153017(props, isSVG, skipChildren) {}
const $a13b7177169dd23a$export$6acf61af03e62db = false;
const $a13b7177169dd23a$export$40edfb7eeb78c4e8 = false;
const $a13b7177169dd23a$var$SVG_NAMESPACE = "http://www.w3.org/2000/svg";
function $a13b7177169dd23a$var$createElement(tagName, isSVG = false, is) {
    return isSVG ? document.createElementNS($a13b7177169dd23a$var$SVG_NAMESPACE, tagName) : document.createElement(tagName, {
        is: is
    });
}
const $a13b7177169dd23a$export$fa8d919ba61d84db = (...args)=>{
    (0, $iIpFz.enableHydration)();
    return $a13b7177169dd23a$var$hydrate$1(...args);
};
function $a13b7177169dd23a$export$602eac185826482c(props) {
    const { useShadow: useShadow } = props, marker = document.createTextNode(""), mount = ()=>props.mount || document.body, owner = (0, $iIpFz.getOwner)();
    let content;
    let hydrating = !!(0, $iIpFz.sharedConfig).context;
    (0, $iIpFz.createEffect)(()=>{
        if (hydrating) (0, $iIpFz.getOwner)().user = hydrating = false;
        content || (content = (0, $iIpFz.runWithOwner)(owner, ()=>(0, $iIpFz.createMemo)(()=>props.children)));
        const el = mount();
        if (el instanceof HTMLHeadElement) {
            const [clean, setClean] = (0, $iIpFz.createSignal)(false);
            const cleanup = ()=>setClean(true);
            (0, $iIpFz.createRoot)((dispose)=>$a13b7177169dd23a$export$21a5ca8aa77d35ff(el, ()=>!clean() ? content() : dispose(), null));
            (0, $iIpFz.onCleanup)(cleanup);
        } else {
            const container = $a13b7177169dd23a$var$createElement(props.isSVG ? "g" : "div", props.isSVG), renderRoot = useShadow && container.attachShadow ? container.attachShadow({
                mode: "open"
            }) : container;
            Object.defineProperty(container, "_$host", {
                get () {
                    return marker.parentNode;
                },
                configurable: true
            });
            $a13b7177169dd23a$export$21a5ca8aa77d35ff(renderRoot, content);
            el.appendChild(container);
            props.ref && props.ref(container);
            (0, $iIpFz.onCleanup)(()=>el.contains(container) && el.removeChild(container));
        }
    }, undefined, {
        render: !hydrating
    });
    return marker;
}
function $a13b7177169dd23a$export$9a3ff77bac07eb26(component, props) {
    const cached = (0, $iIpFz.createMemo)(component);
    return (0, $iIpFz.createMemo)(()=>{
        const component = cached();
        switch(typeof component){
            case "function":
                return (0, $iIpFz.untrack)(()=>component(props));
            case "string":
                const isSvg = $a13b7177169dd23a$export$ccaf9b9a82de4b98.has(component);
                const el = (0, $iIpFz.sharedConfig).context ? $a13b7177169dd23a$export$4109ed81edd7716d() : $a13b7177169dd23a$var$createElement(component, isSvg, (0, $iIpFz.untrack)(()=>props.is));
                $a13b7177169dd23a$export$3ae0fd4797ed47c8(el, props, isSvg);
                return el;
        }
    });
}
function $a13b7177169dd23a$export$e18282e419e46834(props) {
    const [, others] = (0, $iIpFz.splitProps)(props, [
        "component"
    ]);
    return $a13b7177169dd23a$export$9a3ff77bac07eb26(()=>props.component, others);
}

});

parcelRegister("gCemA", function(module, exports) {
$parcel$export(module.exports, "AudioLoader", () => (parcelRequire("8BCEu")).AudioLoader);
$parcel$export(module.exports, "AudioTracker", () => (parcelRequire("gfign")).AudioTracker);
$parcel$export(module.exports, "pickRand", () => (parcelRequire("2OJ1y")).pickRand);
$parcel$export(module.exports, "resumeAudioOnClick", () => (parcelRequire("gu6Rz")).resumeAudioOnClick);
parcelRequire("8BCEu");
parcelRequire("gfign");
parcelRequire("2OJ1y");
parcelRequire("gu6Rz");

});
parcelRegister("8BCEu", function(module, exports) {

$parcel$export(module.exports, "AudioLoader", () => $3ea2d296465bb6d5$export$d8d5fccfbf47714e);
class $3ea2d296465bb6d5$export$d8d5fccfbf47714e {
    constructor(context){
        this.context = context;
    }
    async loadBuffer(url) {
        const urls = Array.isArray(url) ? url : [
            url
        ];
        for (const url of urls)try {
            const response = await fetch(url);
            const arrayBuffer = await response.arrayBuffer();
            const buffer = await this.context.decodeAudioData(arrayBuffer);
            return buffer;
        } catch (error) {
            console.error(`Failed to load ${url}`);
            console.error(error);
        }
        throw new Error('Could not load audio from any of the provided URLs');
    }
    async loadNode(url) {
        const buffer = await this.loadBuffer(url);
        const node = this.context.createBufferSource();
        node.buffer = buffer;
        node.connect(this.context.destination);
        return node;
    }
}

});

parcelRegister("gfign", function(module, exports) {

$parcel$export(module.exports, "AudioTracker", () => $f420d007e9653c66$export$acf0dfaf50d03ba2);
class $f420d007e9653c66$export$acf0dfaf50d03ba2 {
    #node;
    #startedAt;
    #stoppedAt;
    #playing;
    constructor(node){
        this.#startedAt = 0;
        this.#stoppedAt = 0;
        this.#playing = false;
        this.#node = node;
        node.addEventListener('ended', ()=>{
            this.#startedAt = 0;
            this.#stoppedAt = 0;
            this.#playing = false;
        });
    }
    get node() {
        return this.#node;
    }
    get playing() {
        return this.#playing;
    }
    play() {
        const offset = this.#stoppedAt;
        this.#node.start(0, offset);
        this.#startedAt = this.#node.context.currentTime - offset;
        this.#stoppedAt = 0;
        this.#playing = true;
    }
    pause() {
        this.#node.stop(0);
        this.#startedAt = 0;
        this.#stoppedAt = this.#node.context.currentTime - this.#startedAt;
        this.#playing = false;
    }
    stop() {
        this.#node.stop(0);
        this.#startedAt = 0;
        this.#stoppedAt = 0;
        this.#playing = false;
    }
    get currentTime() {
        if (this.#stoppedAt) return this.#stoppedAt;
        if (this.#startedAt) {
            const time = this.#node.context.currentTime - this.#startedAt;
            if (this.#node.loop) {
                const duration = this.#node.buffer?.duration;
                if (duration) {
                    this.#startedAt = this.#node.context.currentTime - (time % duration || 0);
                    return time % duration;
                }
            }
            return time;
        }
        return 0;
    }
}

});

parcelRegister("2OJ1y", function(module, exports) {

$parcel$export(module.exports, "pickRand", () => $6de2ed3e5d01eb29$export$e7e792fc9373fc6c);
/** Picks a random element from an array. */ function $6de2ed3e5d01eb29$export$e7e792fc9373fc6c(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
}

});

parcelRegister("gu6Rz", function(module, exports) {

$parcel$export(module.exports, "resumeAudioOnClick", () => $b09c52a8273d8794$export$32c628aad4bf61d0);
function $b09c52a8273d8794$export$32c628aad4bf61d0(context) {
    const resume = async ()=>{
        if (context.state === 'suspended') await context.resume();
        document.removeEventListener('click', resume);
        document.removeEventListener('touchstart', resume);
        document.removeEventListener('touchend', resume);
    };
    document.addEventListener('click', resume);
    document.addEventListener('touchstart', resume);
    document.addEventListener('touchend', resume);
}

});



//# sourceMappingURL=repo.208b6f83.js.map
